const AllQuestions = [


  {
    "id": "math1",
    "subject": "math",
    "question": "If $A = \\{1, 2, 3\\}$ and $B = \\{3, 4, 5\\}$, what is $A \\cap B$?",
    "option1": "{\\{1, 2\\}}",
    "option2": "{\\{3\\}}",
    "option3": "{\\{4, 5\\}}",
    "option4": "{\\{1, 2, 3, 4, 5\\}}",
    "answer": "option2",
    "solution": "The intersection $A \\cap B$ consists of elements common to both sets, which is $\\{3\\}$."
  },
  {
    "id": "math2",
    "subject": "math",
    "question": "If $f(x) = x^2 + 1$, what is the range of $f(x)$ for real $x$?",
    "option1": "$(-\\infty, \\infty)$",
    "option2": "$[0, \\infty)$",
    "option3": "$[1, \\infty)$",
    "option4": "$(1, \\infty)$",
    "answer": "option3",
    "solution": "Since $x^2 \\ge 0$ for all real $x$, $f(x) = x^2 + 1 \\ge 1$. Thus, the range is $[1, \\infty)$."
  },

  {
    "id": "math4",
    "subject": "math",
    "question": "What is the sum of the roots of the quadratic equation $x^2 - 5x + 6 = 0$?",
    "option1": "-5",
    "option2": "5",
    "option3": "6",
    "option4": "-6",
    "answer": "option2",
    "solution": "For $ax^2 + bx + c = 0$, sum of roots $= -b/a = -(-5)/1 = 5$."
  },
  {
    "id": "math5",
    "subject": "math",
    "question": "If a matrix $A$ has order $3 \\times 2$ and $B$ has order $2 \\times 4$, what is the order of matrix $AB$?",
    "option1": "$3 \\times 4$",
    "option2": "$4 \\times 3$",
    "option3": "$2 \\times 2$",
    "option4": "Product does not exist",
    "answer": "option1",
    "solution": "For multiplication $A_{m \\times n} B_{n \\times p}$, the resulting matrix $AB$ has order $m \\times p = 3 \\times 4$."
  },
  {
    "id": "math6",
    "subject": "math",
    "question": "If $|A| = 5$ for a square matrix $A$ of order 3, what is $|\\text{adj}(A)|$?",
    "option1": "5",
    "option2": "15",
    "option3": "25",
    "option4": "125",
    "answer": "option3",
    "solution": "For a matrix of order $n$, $|\\text{adj}(A)| = |A|^{n-1} = 5^{3-1} = 5^2 = 25$."
  },
  {
    "id": "math7",
    "subject": "math",
    "question": "In how many ways can 5 people be seated in a row?",
    "option1": "24",
    "option2": "60",
    "option3": "120",
    "option4": "720",
    "answer": "option3",
    "solution": "The number of arrangements of $n$ distinct items in a row is $n! = 5! = 120$."
  },
  {
    "id": "math8",
    "subject": "math",
    "question": "What is the value of $\\binom{n}{0} + \\binom{n}{1} + \\dots + \\binom{n}{n}$?",
    "option1": "$n^2$",
    "option2": "$2^n$",
    "option3": "$2^{n-1}$",
    "option4": "$2^{n+1}$",
    "answer": "option2",
    "solution": "The sum of all binomial coefficients in the expansion of $(1+x)^n$ when $x=1$ is $2^n$."
  },
  {
    "id": "math9",
    "subject": "math",
    "question": "What is the $n$-th term of the Arithmetic Progression (AP) with first term $a$ and common difference $d$?",
    "option1": "$a + nd$",
    "option2": "$a + (n-1)d$",
    "option3": "$a + (n+1)d$",
    "option4": "$a \\cdot r^{n-1}$",
    "answer": "option2",
    "solution": "The general term of an AP is given by $T_n = a + (n-1)d$."
  },
  {
    "id": "math10",
    "subject": "math",
    "question": "What is the limit $\\lim_{x \\to 0} \\frac{\\sin x}{x}$?",
    "option1": "0",
    "option2": "1",
    "option3": "Undefined",
    "option4": "$\\infty$",
    "answer": "option2",
    "solution": "By standard trigonometric limits, $\\lim_{x \\to 0} \\frac{\\sin x}{x} = 1$."
  },
  {
    "id": "math11",
    "subject": "math",
    "question": "What is $\\int x^n dx$ for $n \\neq -1$?",
    "option1": "$nx^{n-1} + C$",
    "option2": "$\\frac{x^{n+1}}{n+1} + C$",
    "option3": "$\\frac{x^n}{n} + C$",
    "option4": "$\\ln(x) + C$",
    "answer": "option2",
    "solution": "By the power rule for integration, $\\int x^n dx = \\frac{x^{n+1}}{n+1} + C$."
  },
  {
    "id": "math12",
    "subject": "math",
    "question": "What is the order of the differential equation $\\frac{d^2y}{dx^2} + 3\\left(\\frac{dy}{dx}\\right)^3 + y = 0$?",
    "option1": "1",
    "option2": "2",
    "option3": "3",
    "option4": "6",
    "answer": "option2",
    "solution": "The order is determined by the highest derivative present, which is $\\frac{d^2y}{dx^2}$ (order 2)."
  },
  {
    "id": "math13",
    "subject": "math",
    "question": "What is the distance between the points $(1, 2)$ and $(4, 6)$?",
    "option1": "3",
    "option2": "4",
    "option3": "5",
    "option4": "7",
    "answer": "option3",
    "solution": "Distance $d = \\sqrt{(4-1)^2 + (6-2)^2} = \\sqrt{3^2 + 4^2} = \\sqrt{9+16} = 5$."
  },

  {
    "id": "math15",
    "subject": "math",
    "question": "If $\\vec{a} = \\hat{i} + 2\\hat{j}$ and $\\vec{b} = 2\\hat{i} - \\hat{j}$, what is $\\vec{a} \\cdot \\vec{b}$?",
    "option1": "0",
    "option2": "4",
    "option3": "5",
    "option4": "-1",
    "answer": "option1",
    "solution": "Dot product $\\vec{a} \\cdot \\vec{b} = (1)(2) + (2)(-1) = 2 - 2 = 0$."
  },
  {
    "id": "math16",
    "subject": "math",
    "question": "A fair coin is tossed twice. What is the probability of getting at least one head?",
    "option1": "1/4",
    "option2": "1/2",
    "option3": "3/4",
    "option4": "1",
    "answer": "option3",
    "solution": "Sample space = {HH, HT, TH, TT}. Outcomes with at least one head = {HH, HT, TH}. Probability = 3/4."
  },
  {
    "id": "math17",
    "subject": "math",
    "question": "What is the value of $\\sin(90^\\circ - \\theta)$?",
    "option1": "$\\sin\\theta$",
    "option2": "$\\cos\\theta$",
    "option3": "$-\\cos\\theta$",
    "option4": "$\\tan\\theta$",
    "answer": "option2",
    "solution": "By complementary angle identities, $\\sin(90^\\circ - \\theta) = \\cos\\theta$."
  },
  {
    "id": "math18",
    "subject": "math",
    "question": "If set $A$ has $m$ elements, what is the total number of subsets of $A$?",
    "option1": "$m^2$",
    "option2": "$2^m$",
    "option3": "$2m$",
    "option4": "$m!$",
    "answer": "option2",
    "solution": "The power set of a set with $m$ elements contains $2^m$ subsets."
  },
  {
    "id": "math19",
    "subject": "math",
    "question": "What is the modulus of the complex number $z = 3 + 4i$?",
    "option1": "5",
    "option2": "7",
    "option3": "25",
    "option4": "1",
    "answer": "option1",
    "solution": "$|z| = \\sqrt{\\text{Re}(z)^2 + \\text{Im}(z)^2} = \\sqrt{3^2 + 4^2} = \\sqrt{25} = 5$."
  },
  {
    "id": "math20",
    "subject": "math",
    "question": "If the discriminant of $ax^2 + bx + c = 0$ is zero, the roots are:",
    "option1": "Real and distinct",
    "option2": "Real and equal",
    "option3": "Complex conjugates",
    "option4": "Purely imaginary",
    "answer": "option2",
    "solution": "When $D = b^2 - 4ac = 0$, both roots are equal to $-b / (2a)$."
  },
  {
    "id": "math21",
    "subject": "math",
    "question": "If $A$ is a square matrix, then $A + A^T$ is always:",
    "option1": "Symmetric",
    "option2": "Skew-symmetric",
    "option3": "Diagonal",
    "option4": "Identity",
    "answer": "option1",
    "solution": "Taking transpose: $(A + A^T)^T = A^T + (A^T)^T = A^T + A = A + A^T$. Thus it is symmetric."
  },
  {
    "id": "math22",
    "subject": "math",
    "question": "What is the determinant of a $3 \\times 3$ identity matrix $I$?",
    "option1": "0",
    "option2": "1",
    "option3": "3",
    "option4": "9",
    "answer": "option2",
    "solution": "The determinant of any identity matrix is always 1."
  },
  {
    "id": "math23",
    "subject": "math",
    "question": "What is the value of $P(n, 1)$?",
    "option1": "1",
    "option2": "$n$",
    "option3": "$n!$",
    "option4": "0",
    "answer": "option2",
    "solution": "$P(n, 1) = \\frac{n!}{(n-1)!} = n$."
  },
  {
    "id": "math24",
    "subject": "math",
    "question": "What is the total number of terms in the expansion of $(x + y)^{10}$?",
    "option1": "10",
    "option2": "11",
    "option3": "20",
    "option4": "1024",
    "answer": "option2",
    "solution": "The expansion of $(x + y)^n$ contains $n + 1$ terms. For $n = 10$, terms = 11."
  },
  {
    "id": "math25",
    "subject": "math",
    "question": "What is the sum of an infinite GP with first term $a = 2$ and common ratio $r = 1/2$?",
    "option1": "2",
    "option2": "3",
    "option3": "4",
    "option4": "1",
    "answer": "option3",
    "solution": "$S_\\infty = \\frac{a}{1-r} = \\frac{2}{1 - 1/2} = \\frac{2}{1/2} = 4$."
  },
  {
    "id": "math26",
    "subject": "math",
    "question": "What is $\\frac{d}{dx}(\\mathrm{e}^x)$?",
    "option1": "$x \\mathrm{e}^{x-1}$",
    "option2": "$\\mathrm{e}^x$",
    "option3": "$\\ln(x)$",
    "option4": "$\\frac{1}{x}$",
    "answer": "option2",
    "solution": "The derivative of the exponential function $\\mathrm{e}^x$ with respect to $x$ is $\\mathrm{e}^x$."
  },
  {
    "id": "math27",
    "subject": "math",
    "question": "What is $\\int_0^1 x dx$?",
    "option1": "0",
    "option2": "1/2",
    "option3": "1",
    "option4": "2",
    "answer": "option2",
    "solution": "$\\int_0^1 x dx = \\left[ \\frac{x^2}{2} \\right]_0^1 = \\frac{1}{2} - 0 = \\frac{1}{2}$."
  },
  {
    "id": "math28",
    "subject": "math",
    "question": "What is the integrating factor (I.F.) for the differential equation $\\frac{dy}{dx} + P(x)y = Q(x)$?",
    "option1": "$\\mathrm{e}^{\\int P(x)dx}$",
    "option2": "$\\int P(x)dx$",
    "option3": "$\\mathrm{e}^{P(x)}$",
    "option4": "$\\mathrm{e}^{\\int Q(x)dx}$",
    "answer": "option1",
    "solution": "For a first-order linear differential equation, $\\text{I.F.} = \\mathrm{e}^{\\int P(x)dx}$."
  },
  {
    "id": "math29",
    "subject": "math",
    "question": "What is the slope of a line perpendicular to $y = 2x + 3$?",
    "option1": "2",
    "option2": "-2",
    "option3": "1/2",
    "option4": "-1/2",
    "answer": "option4",
    "solution": "Perpendicular slopes satisfy $m_1 \\cdot m_2 = -1$. Given $m_1 = 2$, $m_2 = -1/2$."
  },
  {
    "id": "math30",
    "subject": "math",
    "question": "Direction cosines $l, m, n$ of a line satisfy which relation?",
    "option1": "$l + m + n = 1$",
    "option2": "$l^2 + m^2 + n^2 = 1$",
    "option3": "$l^2 + m^2 + n^2 = 0$",
    "option4": "$l^2 - m^2 + n^2 = 1$",
    "answer": "option2",
    "solution": "The sum of squares of direction cosines is always 1: $\\cos^2\\alpha + \\cos^2\\beta + \\cos^2\\gamma = 1$."
  },
  {
    "id": "math31",
    "subject": "math",
    "question": "If $\\vec{a}$ and $\\vec{b}$ are perpendicular vectors, what is $\\vec{a} \\cdot \\vec{b}$?",
    "option1": "0",
    "option2": "1",
    "option3": "$|\\vec{a}||\\vec{b}|$",
    "option4": "-1",
    "answer": "option1",
    "solution": "Dot product $= |\\vec{a}||\\vec{b}|\\cos 90^\\circ = 0$."
  },
  {
    "id": "math32",
    "subject": "math",
    "question": "What is the mean of the first $n$ natural numbers?",
    "option1": "$\\frac{n}{2}$",
    "option2": "$\\frac{n+1}{2}$",
    "option3": "$n+1$",
    "option4": "$\\frac{n(n+1)}{2}$",
    "answer": "option2",
    "solution": "Sum $= \\frac{n(n+1)}{2}$. Mean $= \\frac{\\text{Sum}}{n} = \\frac{n+1}{2}$."
  },
  {
    "id": "math33",
    "subject": "math",
    "question": "What is $\\tan(45^\\circ)$?",
    "option1": "0",
    "option2": "4",
    "option3": "1",
    "option4": "5",
    "answer": "option3",
    "solution": "$\\tan(45^\\circ) = \\frac{\\sin 45^\\circ}{\\cos 45^\\circ} = 1$."
  },
  {
    "id": "math34",
    "subject": "math",
    "question": "If $A \\subset B$, then $A \\cup B$ equals:",
    "option1": "$A$",
    "option2": "$B$",
    "option3": "$\\emptyset$",
    "option4": "$A \\cap B$",
    "answer": "option2",
    "solution": "Since every element of $A$ is in $B$, combining them gives set $B$."
  },
  {
    "id": "math35",
    "subject": "math",
    "question": "What is the argument of a purely positive real number?",
    "option1": "0",
    "option2": "$\\pi/2$",
    "option3": "$\\pi$",
    "option4": "$-\\pi/2$",
    "answer": "option1",
    "solution": "Positive real numbers lie on the positive x-axis, so their argument is 0."
  },
  {
    "id": "math36",
    "subject": "math",
    "question": "The nature of roots of $x^2 + x + 1 = 0$ is:",
    "option1": "Real and distinct",
    "option2": "Real and equal",
    "option3": "Non-real complex",
    "option4": "Rational",
    "answer": "option3",
    "solution": "$D = 1^2 - 4(1)(1) = -3 < 0$. Roots are non-real complex numbers."
  },
  {
    "id": "math37",
    "subject": "math",
    "question": "If a matrix $A$ is skew-symmetric, then $A^T$ equals:",
    "option1": "$A$",
    "option2": "$-A$",
    "option3": "$A^{-1}$",
    "option4": "$I$",
    "answer": "option2",
    "solution": "By definition, a matrix is skew-symmetric if $A^T = -A$."
  },
  {
    "id": "math38",
    "subject": "math",
    "question": "If matrix $A$ is singular, then its determinant $|A|$ is:",
    "option1": "0",
    "option2": "1",
    "option3": "-1",
    "option4": "Undefined",
    "answer": "option1",
    "solution": "A square matrix is called singular if and only if its determinant is zero."
  },
  {
    "id": "math39",
    "subject": "math",
    "question": "What is $\\binom{n}{r} + \\binom{n}{r-1}$ equal to?",
    "option1": "$\\binom{n}{r+1}$",
    "option2": "$\\binom{n+1}{r}$",
    "option3": "$\\binom{n+1}{r+1}$",
    "option4": "$\\binom{n}{r}$",
    "answer": "option2",
    "solution": "Pascal's identity states $\\binom{n}{r} + \\binom{n}{r-1} = \\binom{n+1}{r}$."
  },
  {
    "id": "math40",
    "subject": "math",
    "question": "Middle term in expansion of $(a+b)^8$ is:",
    "option1": "$T_4$",
    "option2": "$T_5$",
    "option3": "$T_6$",
    "option4": "$T_4$ and $T_5$",
    "answer": "option2",
    "solution": "For even $n=8$, middle term is $\\left(\\frac{8}{2} + 1\\right) = 5$-th term ($T_5$)."
  },

  {
    "id": "math42",
    "subject": "math",
    "question": "Derivative of $\\cos x$ with respect to $x$ is:",
    "option1": "$\\sin x$",
    "option2": "$-\\sin x$",
    "option3": "$\\sec^2 x$",
    "option4": "$-\\cos x$",
    "answer": "option2",
    "solution": "$\\frac{d}{dx}(\\cos x) = -\\sin x$."
  },
  {
    "id": "math43",
    "subject": "math",
    "question": "What is $\\int \\frac{1}{x} dx$?",
    "option1": "$-\\frac{1}{x^2} + C$",
    "option2": "$\\ln|x| + C$",
    "option3": "$\\mathrm{e}^x + C$",
    "option4": "$1 + C$",
    "answer": "option2",
    "solution": "The standard integral of $1/x$ is $\\ln|x| + C$."
  },
  {
    "id": "math44",
    "subject": "math",
    "question": "Degree of differential equation $\\left(\\frac{d^2y}{dx^2}\\right)^2 + \\frac{dy}{dx} = 0$ is:",
    "option1": "1",
    "option2": "2",
    "option3": "3",
    "option4": "Not defined",
    "answer": "option2",
    "solution": "Degree is the power of highest order derivative $\\frac{d^2y}{dx^2}$, which is 2."
  },
  {
    "id": "math45",
    "subject": "math",
    "question": "Equation of circle centered at origin with radius $R$ is:",
    "option1": "x + y = R",
    "option2": "$x^2 + y^2 = R^2$",
    "option3": "$x^2 - y^2 = R^2$",
    "option4": "$xy = R^2$",
    "answer": "option2",
    "solution": "By distance formula, distance from $(0,0)$ to $(x,y)$ is $R$, so $x^2 + y^2 = R^2$."
  },
  {
    "id": "math46",
    "subject": "math",
    "question": "Equation of $xy$-plane in 3D geometry is:",
    "option1": "$x = 0$",
    "option2": "$y = 0$",
    "option3": "$z = 0$",
    "option4": "$x + y = 0$",
    "answer": "option3",
    "solution": "Every point in the $xy$-plane has a $z$-coordinate equal to 0."
  },
  {
    "id": "math47",
    "subject": "math",
    "question": "Magnitude of vector $\\vec{v} = 3\\hat{i} - 4\\hat{j}$ is:",
    "option1": "1",
    "option2": "5",
    "option3": "7",
    "option4": "25",
    "answer": "option2",
    "solution": "$|\\vec{v}| = \\sqrt{3^2 + (-4)^2} = \\sqrt{9 + 16} = 5$."
  },
  {
    "id": "math48",
    "subject": "math",
    "question": "If $P(A) = 0.3$ and $P(B) = 0.4$ for independent events, what is $P(A \\cap B)$?",
    "option1": "0.7",
    "option2": "0.12",
    "option3": "0.1",
    "option4": "0.75",
    "answer": "option2",
    "solution": "For independent events, $P(A \\cap B) = P(A) \\cdot P(B) = 0.3 \\times 0.4 = 0.12$."
  },
  {
    "id": "math49",
    "subject": "math",
    "question": "Value of $\\cos^2\\theta + \\sin^2\\theta$ is:",
    "option1": "0",
    "option2": "1",
    "option3": "2",
    "option4": "-1",
    "answer": "option2",
    "solution": "This is fundamental trigonometric identity: $\\sin^2\\theta + \\cos^2\\theta = 1$."
  },
  {
    "id": "math50",
    "subject": "math",
    "question": "Empty set is represented by:",
    "option1": "{\\{0\\}}",
    "option2": "$\\emptyset$",
    "option3": "{\\$\\emptyset\\$}",
    "option4": "0",
    "answer": "option2",
    "solution": "The empty set contains no elements and is denoted by $\\emptyset$ or $\\{\\}$."
  },
  {
    "id": "math51",
    "subject": "math",
    "question": "Value of $i^2$ is:",
    "option1": "1",
    "option2": "-1",
    "option3": "$i$",
    "option4": "0",
    "answer": "option2",
    "solution": "By definition of imaginary unit, $i = \\sqrt{-1}$, so $i^2 = -1$."
  },
  {
    "id": "math52",
    "subject": "math",
    "question": "Roots of equation $x^2 - 9 = 0$ are:",
    "option1": "3 only",
    "option2": "-3 only",
    "option3": "$\\pm 3$",
    "option4": "$\\pm 9$",
    "answer": "option3",
    "solution": "$x^2 = 9 \\implies x = \\pm \\sqrt{9} = \\pm 3$."
  },
  {
    "id": "math53",
    "subject": "math",
    "question": "Identity matrix $I$ satisfies:",
    "option1": "$AI = A$",
    "option2": "$AI = I$",
    "option3": "$AI = 0$",
    "option4": "$AI = A^2$",
    "answer": "option1",
    "solution": "Multiplying any matrix $A$ by identity matrix $I$ yields $A$."
  },
  {
    "id": "math54",
    "subject": "math",
    "question": "If $|A| = 0$, then $A^{-1}$:",
    "option1": "Is equal to $A$",
    "option2": "Is equal to $I$",
    "option3": "Does not exist",
    "option4": "Is equal to $\\text{adj}(A)$",
    "answer": "option3",
    "solution": "$A^{-1} = \\frac{\\text{adj}(A)}{|A|}$. Division by zero is undefined, so inverse does not exist."
  },
  {
    "id": "math55",
    "subject": "math",
    "question": "Value of $0!$ is:",
    "option1": "0",
    "option2": "1",
    "option3": "Undefined",
    "option4": "$\\infty$",
    "answer": "option2",
    "solution": "By mathematical definition, $0! = 1$."
  },
  {
    "id": "math56",
    "subject": "math",
    "question": "General term $T_{r+1}$ in expansion of $(a+b)^n$ is:",
    "option1": "$\\binom{n}{r} a^{n-r} b^r$",
    "option2": "$\\binom{n}{r} a^r b^{n-r}$",
    "option3": "$\\binom{n}{r+1} a^{n-r} b^r$",
    "option4": "$\\binom{n}{r} a^n b^r$",
    "answer": "option1",
    "solution": "Binomial theorem defines general term as $T_{r+1} = \\binom{n}{r} a^{n-r} b^r$."
  },
  {
    "id": "math57",
    "subject": "math",
    "question": "Common ratio of GP $2, 6, 18, 54, \\dots$ is:",
    "option1": "2",
    "option2": "3",
    "option3": "4",
    "option4": "6",
    "answer": "option2",
    "solution": "$r = 6/2 = 3$."
  },
  {
    "id": "math58",
    "subject": "math",
    "question": "If $f(x) = |x|$, function is not differentiable at:",
    "option1": "$x = 1$",
    "option2": "$x = -1$",
    "option3": "$x = 0$",
    "option4": "$x = 2$",
    "answer": "option3",
    "solution": "Absolute value function has sharp corner at origin, so left derivative $(-1) \\neq$ right derivative $(1)$ at $x=0$."
  },
  {
    "id": "math59",
    "subject": "math",
    "question": "What is $\\int \\mathrm{e}^x dx$?",
    "option1": "$\\mathrm{e}^x + C$",
    "option2": "$x\\mathrm{e}^x + C$",
    "option3": "$\\mathrm{e}^{x+1} + C$",
    "option4": "$\\frac{\\mathrm{e}^x}{x} + C$",
    "answer": "option1",
    "solution": "Integral of exponential function $\\mathrm{e}^x$ is itself plus constant $C$."
  },
  {
    "id": "math60",
    "subject": "math",
    "question": "General solution of $\\frac{dy}{dx} = 0$ is:",
    "option1": "$y = x + C$",
    "option2": "$y = C$",
    "option3": "$y = 0$",
    "option4": "$x = C$",
    "answer": "option2",
    "solution": "Integrating both sides gives $y = C$, where $C$ is a constant."
  },
  {
    "id": "math61",
    "subject": "math",
    "question": "Slope of line $3x + 4y = 12$ is:",
    "option1": "3/4",
    "option2": "-3/4",
    "option3": "-4/3",
    "option4": "4/3",
    "answer": "option2",
    "solution": "Rewriting in slope-intercept form $y = -\\frac{3}{4}x + 3$, slope $m = -3/4$."
  },

  {
    "id": "math63",
    "subject": "math",
    "question": "Cross product $\\hat{i} \\times \\hat{j}$ equals:",
    "option1": "$\\hat{k}$",
    "option2": "$-\\hat{k}$",
    "option3": "0",
    "option4": "1",
    "answer": "option1",
    "solution": "By right-hand rule for standard unit vectors, $\\hat{i} \\times \\hat{j} = \\hat{k}$."
  },
  {
    "id": "math64",
    "subject": "math",
    "question": "Variance of constant value $k$ is:",
    "option1": "$k$",
    "option2": "$k^2$",
    "option3": "0",
    "option4": "1",
    "answer": "option3",
    "solution": "Since constant data has no spread, variance is 0."
  },
  {
    "id": "math65",
    "subject": "math",
    "question": "Period of $\\sin x$ is:",
    "option1": "$\\pi$",
    "option2": "$2\\pi$",
    "option3": "$\\pi/2$",
    "option4": "$4\\pi$",
    "answer": "option2",
    "solution": "Sine function repeats values every $2\\pi$ radians."
  },
  {
    "id": "math66",
    "subject": "math",
    "question": "Number of subsets of set with 3 elements is:",
    "option1": "3",
    "option2": "6",
    "option3": "8",
    "option4": "9",
    "answer": "option3",
    "solution": "$2^3 = 8$."
  },
  {
    "id": "math67",
    "subject": "math",
    "question": "Conjugate of $z = 2 - 3i$ is:",
    "option1": "$-2 - 3i$",
    "option2": "$2 + 3i$",
    "option3": "$-2 + 3i$",
    "option4": "$3 - 2i$",
    "answer": "option2",
    "solution": "Complex conjugate is obtained by changing sign of imaginary part: $\\bar{z} = 2 + 3i$."
  },
  {
    "id": "math68",
    "subject": "math",
    "question": "Product of roots of quadratic equation $2x^2 - 4x + 6 = 0$ is:",
    "option1": "2",
    "option2": "3",
    "option3": "-3",
    "option4": "6",
    "answer": "option2",
    "solution": "Product of roots $= c/a = 6/2 = 3$."
  },
  {
    "id": "math69",
    "subject": "math",
    "question": "Trace of matrix $A = \\begin{pmatrix} 1 & 2 \\\\ 3 & 4 \\end{pmatrix}$ is:",
    "option1": "5",
    "option2": "10",
    "option3": "-2",
    "option4": "7",
    "answer": "option1",
    "solution": "Trace is sum of diagonal elements: $1 + 4 = 5$."
  },
  {
    "id": "math70",
    "subject": "math",
    "question": "If $A$ is $2 \\times 2$ matrix, $|k A|$ equals:",
    "option1": "$k |A|$",
    "option2": "$k^2 |A|$",
    "option3": "$2k |A|$",
    "option4": "$|A|$",
    "answer": "option2",
    "solution": "For $n \\times n$ matrix, $|kA| = k^n |A|$. Here $n=2$, so $k^2 |A|$."
  },
  {
    "id": "math71",
    "subject": "math",
    "question": "Value of $\\binom{n}{n}$ is:",
    "option1": "0",
    "option2": "1",
    "option3": "$n$",
    "option4": "$n!$",
    "answer": "option2",
    "solution": "$\\binom{n}{n} = \\frac{n!}{n!(n-n)!} = \\frac{1}{0!} = 1$."
  },
  {
    "id": "math72",
    "subject": "math",
    "question": "Coefficient of $x^0$ (constant term) in $(x + 1/x)^2$ is:",
    "option1": "1",
    "option2": "2",
    "option3": "3",
    "option4": "0",
    "answer": "option2",
    "solution": "$(x + 1/x)^2 = x^2 + 2(x)(1/x) + 1/x^2 = x^2 + 2 + x^{-2}$. Constant term is 2."
  },
  {
    "id": "math73",
    "subject": "math",
    "question": "Arithmetic Mean (AM) of numbers 4 and 16 is:",
    "option1": "8",
    "option2": "10",
    "option3": "12",
    "option4": "20",
    "answer": "option2",
    "solution": "$\\text{AM} = \\frac{4 + 16}{2} = \\frac{20}{2} = 10$."
  },
  {
    "id": "math74",
    "subject": "math",
    "question": "Derivative of $\\ln x$ with respect to $x$ is:",
    "option1": "1",
    "option2": "1/x",
    "option3": "$\\mathrm{e}^x$",
    "option4": "$-1/x^2$",
    "answer": "option2",
    "solution": "Standard derivative of natural logarithm is $\\frac{d}{dx}(\\ln x) = \\frac{1}{x}$."
  },
  {
    "id": "math75",
    "subject": "math",
    "question": "What is $\\int \\cos x dx$?",
    "option1": "$\\sin x + C$",
    "option2": "$-\\sin x + C$",
    "option3": "$\\tan x + C$",
    "option4": "$-\\cos x + C$",
    "answer": "option1",
    "solution": "Standard integral of cosine is $\\int \\cos x dx = \\sin x + C$."
  },
  {
    "id": "math76",
    "subject": "math",
    "question": "Solution of differential equation $\\frac{dy}{dx} = y$ is:",
    "option1": "$y = C x$",
    "option2": "$y = C \\mathrm{e}^x$",
    "option3": "$y = x + C$",
    "option4": "$y = C \\ln x$",
    "answer": "option2",
    "solution": "Separating variables: $\\frac{dy}{y} = dx \\implies \\ln y = x + c_1 \\implies y = C \\mathrm{e}^x$."
  },
  {
    "id": "math77",
    "subject": "math",
    "question": "Midpoint of line segment joining $(2, 4)$ and $(6, 8)$ is:",
    "option1": "$(4, 6)$",
    "option2": "$(3, 5)$",
    "option3": "$(8, 12)$",
    "option4": "$(4, 4)$",
    "answer": "option1",
    "solution": "Midpoint $=\\left(\\frac{2+6}{2}, \\frac{4+8}{2}\\right) = (4, 6)$."
  },
  {
    "id": "math78",
    "subject": "math",
    "question": "Equation of line parallel to $z$-axis in 3D passing through origin is:",
    "option1": "$x = 0, y = 0$",
    "option2": "$y = 0, z = 0$",
    "option3": "$x = 0, z = 0$",
    "option4": "$x = y = z$",
    "answer": "option1",
    "solution": "The $z$-axis itself passes through origin and is defined by $x=0$ and $y=0$."
  },
  {
    "id": "math79",
    "subject": "math",
    "question": "If vector $\\vec{a}$ has magnitude 4, what is $|-3\\vec{a}|$?",
    "option1": "-12",
    "option2": "12",
    "option3": "7",
    "option4": "1",
    "answer": "option2",
    "solution": "$|-3\\vec{a}| = |-3| \\cdot |\\vec{a}| = 3 \\cdot 4 = 12$."
  },
  {
    "id": "math80",
    "subject": "math",
    "question": "Probability of impossible event is:",
    "option1": "0",
    "option2": "1",
    "option3": "1/2",
    "option4": "-1",
    "answer": "option1",
    "solution": "An impossible event contains no favorable outcomes, so its probability is 0."
  },
  {
    "id": "math81",
    "subject": "math",
    "question": "Value of $\\sec^2\\theta - \\tan^2\\theta$ is:",
    "option1": "0",
    "option2": "1",
    "option3": "-1",
    "option4": "2",
    "answer": "option2",
    "solution": "Standard trigonometric identity: $1 + \\tan^2\\theta = \\sec^2\\theta \\implies \\sec^2\\theta - \\tan^2\\theta = 1$."
  },
  {
    "id": "math82",
    "subject": "math",
    "question": "If $A = \\emptyset$, power set $P(A)$ is:",
    "option1": "$\\emptyset$",
    "option2": "{\\$\\emptyset\\$}",
    "option3": "{0}",
    "option4": "Undefined",
    "answer": "option2",
    "solution": "Power set of empty set contains 1 element: the empty set itself, i.e., $\\{\\emptyset\\}$."
  },

  {
    "id": "math84",
    "subject": "math",
    "question": "Minimum value of $x^2 + 4x + 5$ is:",
    "option1": "0",
    "option2": "1",
    "option3": "5",
    "option4": "-4",
    "answer": "option2",
    "solution": "Completing square: $(x+2)^2 + 1$. Minimum value occurs at $x = -2$, giving minimum value 1."
  },
  {
    "id": "math85",
    "subject": "math",
    "question": "Inverse of identity matrix $I$ is:",
    "option1": "0",
    "option2": "$I$",
    "option3": "$-I$",
    "option4": "Does not exist",
    "answer": "option2",
    "solution": "Since $I \\cdot I = I$, inverse of identity matrix is identity matrix itself."
  },
  {
    "id": "math86",
    "subject": "math",
    "question": "Determinant of matrix with two identical rows is:",
    "option1": "1",
    "option2": "0",
    "option3": "-1",
    "option4": "Undefined",
    "answer": "option2",
    "solution": "By determinant properties, if any two rows/columns are identical, value is 0."
  },
  {
    "id": "math87",
    "subject": "math",
    "question": "Number of circular permutations of $n$ distinct objects is:",
    "option1": "$n!$",
    "option2": "$(n-1)!$",
    "option3": "$(n+1)!$",
    "option4": "$n!/2$",
    "answer": "option2",
    "solution": "Fixing one position around circle leaves $(n-1)$ items to arrange in $(n-1)!$ ways."
  },
  {
    "id": "math88",
    "subject": "math",
    "question": "Sum of coefficients in expansion of $(1+x)^5$ is:",
    "option1": "16",
    "option2": "32",
    "option3": "64",
    "option4": "5",
    "answer": "option2",
    "solution": "Substituting $x = 1$ gives $(1+1)^5 = 2^5 = 32$."
  },
  {
    "id": "math89",
    "subject": "math",
    "question": "Sum of first $n$ natural numbers is given by:",
    "option1": "$n^2$",
    "option2": "$\\frac{n(n+1)}{2}$",
    "option3": "$\\frac{n(n-1)}{2}$",
    "option4": "$\\frac{n(n+1)(2n+1)}{6}$",
    "answer": "option2",
    "solution": "Standard summation formula: $\\sum k = \\frac{n(n+1)}{2}$."
  },
  {
    "id": "math90",
    "subject": "math",
    "question": "Derivative of $\\tan x$ with respect to $x$ is:",
    "option1": "$\\sec x$",
    "option2": "$\\sec^2 x$",
    "option3": "$-\\csc^2 x$",
    "option4": "$\\tan^2 x$",
    "answer": "option2",
    "solution": "Standard trigonometric derivative rule: $\\frac{d}{dx}(\\tan x) = \\sec^2 x$."
  },
  {
    "id": "math91",
    "subject": "math",
    "question": "What is $\\int_a^a f(x) dx$?",
    "option1": "1",
    "option2": "0",
    "option3": "$f(a)$",
    "option4": "$2f(a)$",
    "answer": "option2",
    "solution": "Definite integral over interval of length 0 evaluates to 0."
  },
  {
    "id": "math92",
    "subject": "math",
    "question": "Degree of differential equation $y = x \\frac{dy}{dx} + \\left(\\frac{dy}{dx}\\right)^2$ is:",
    "option1": "1",
    "option2": "2",
    "option3": "3",
    "option4": "0",
    "answer": "option2",
    "solution": "Highest derivative is $\\frac{dy}{dx}$ (order 1) and its highest exponent is 2 (degree 2)."
  },
  {
    "id": "math93",
    "subject": "math",
    "question": "Y-intercept of line $y = 3x - 7$ is:",
    "option1": "3",
    "option2": "-7",
    "option3": "7",
    "option4": "-3",
    "answer": "option2",
    "solution": "In $y = mx + c$, $c$ is y-intercept. Here $c = -7$."
  },
  {
    "id": "math94",
    "subject": "math",
    "question": "If direction ratios of line are $(1, 2, 2)$, what is its direction cosine $l$?",
    "option1": "1/3",
    "option2": "2/3",
    "option3": "1/9",
    "option4": "1",
    "answer": "option1",
    "solution": "$\t\\text{Magnitude} = \\sqrt{1^2 + 2^2 + 2^2} = \\sqrt{9} = 3$. So $l = 1/3$."
  },
  {
    "id": "math95",
    "subject": "math",
    "question": "Unit vector in direction of $\\vec{a}$ is:",
    "option1": "$\\vec{a} \\cdot |\\vec{a}|$",
    "option2": "$\\frac{\\vec{a}}{|\\vec{a}|}$",
    "option3": "$\\frac{|\\vec{a}|}{\\vec{a}}$",
    "option4": "$\\vec{a} + |\\vec{a}|$",
    "answer": "option2",
    "solution": "A unit vector $\\hat{a}$ is defined as vector divided by its magnitude $\\frac{\\vec{a}}{|\\vec{a}|}$."
  },
  {
    "id": "math96",
    "subject": "math",
    "question": "If $P(A) = 0.6$, what is $P(A')$ (complement of event $A$)?",
    "option1": "0.6",
    "option2": "0.4",
    "option3": "0",
    "option4": "1",
    "answer": "option2",
    "solution": "$P(A') = 1 - P(A) = 1 - 0.6 = 0.4$."
  },
  {
    "id": "math97",
    "subject": "math",
    "question": "Value of $\\cos(180^\\circ)$ is:",
    "option1": "0",
    "option2": "1",
    "option3": "-1",
    "option4": "Undefined",
    "answer": "option3",
    "solution": "At $\\pi$ radians ($180^\\circ$), cosine function value is $-1$."
  },
  {
    "id": "math98",
    "subject": "math",
    "question": "Cartesian product $A \\times B$ for $A = \\{1\\}, B = \\{2, 3\\}$ is:",
    "option1": "{\\{(1, 2), (1, 3)\\}}",
    "option2": "{\\{(2, 1), (3, 1)\\}}",
    "option3": "{\\{1, 2, 3\\}}",
    "option4": "{\\{(1, 1), (2, 3)\\}}",
    "answer": "option1",
    "solution": "$A \\times B = \\{(a, b) : a \\in A, b \\in B\\} = \\{(1, 2), (1, 3)\\}$."
  },
  {
    "id": "math99",
    "subject": "math",
    "question": "If $\\omega$ is non-real cube root of unity, value of $1 + \\omega + \\omega^2$ is:",
    "option1": "1",
    "option2": "0",
    "option3": "-1",
    "option4": "$\\omega$",
    "answer": "option2",
    "solution": "Standard complex property of cube roots of unity: $1 + \\omega + \\omega^2 = 0$."
  },
  {
    "id": "math100",
    "subject": "math",
    "question": "The slope of x-axis is:",
    "option1": "0",
    "option2": "1",
    "option3": "Undefined",
    "option4": "-1",
    "answer": "option1",
    "solution": "Angle with positive x-axis is $0^\\circ$, so slope $m = \\tan(0^\\circ) = 0$."
  },
  

  {
    "id": "physics1",
    "subject": "physics",
    "question": "Which of the following physical quantities has the same dimensions as Planck's constant?",
    "option1": "Linear momentum",
    "option2": "Angular momentum",
    "option3": "Energy",
    "option4": "Power",
    "answer": "option2",
    "solution": "The dimension of Planck's constant (h) is [M L^2 T^-1]. Angular momentum (L = r x p) also has dimensions [L] * [M L T^-1] = [M L^2 T^-1]."
  },
  {
    "id": "physics2",
    "subject": "physics",
    "question": "If error in measuring the radius of a sphere is 2%, what is the percentage error in the calculation of its volume?",
    "option1": "2%",
    "option2": "4%",
    "option3": "6%",
    "option4": "8%",
    "answer": "option3",
    "solution": "Volume V = (4/3)pi*r^3. Percentage error in V is 3 * (percentage error in r) = 3 * 2% = 6%."
  },
  {
    "id": "physics3",
    "subject": "physics",
    "question": "A particle moves along a straight line such that its displacement x at time t is given by x = 3t^2 - 6t + 4. At what time is the velocity zero?",
    "option1": "1 s",
    "option2": "2 s",
    "option3": "0.5 s",
    "option4": "3 s",
    "answer": "option1",
    "solution": "Velocity v = dx/dt = 6t - 6. Setting v = 0 gives 6t - 6 = 0, so t = 1 s."
  },
  {
    "id": "physics4",
    "subject": "physics",
    "question": "A projectile is thrown with an initial velocity of (6i + 8j) m/s. What is its horizontal range? (Take g = 10 m/s^2)",
    "option1": "4.8 m",
    "option2": "9.6 m",
    "option3": "12.8 m",
    "option4": "19.2 m",
    "answer": "option2",
    "solution": "Here ux = 6 m/s, uy = 8 m/s. Time of flight T = 2*uy/g = 2*8/10 = 1.6 s. Range R = ux * T = 6 * 1.6 = 9.6 m."
  },
  {
    "id": "physics5",
    "subject": "physics",
    "question": "A block of mass 2 kg rests on a smooth horizontal surface. A horizontal force of 10 N is applied. What is its acceleration?",
    "option1": "2 m/s^2",
    "option2": "5 m/s^2",
    "option3": "10 m/s^2",
    "option4": "20 m/s^2",
    "answer": "option2",
    "solution": "From Newton's second law, F = m * a => a = F/m = 10 / 2 = 5 m/s^2."
  },
  {
    "id": "physics6",
    "subject": "physics",
    "question": "A body of mass 5 kg is moving with a uniform speed of 10 m/s in a circle of radius 2 m. The centripetal force acting on it is:",
    "option1": "250 N",
    "option2": "100 N",
    "option3": "50 N",
    "option4": "25 N",
    "answer": "option1",
    "solution": "Centripetal force F = m*v^2 / r = 5 * (10)^2 / 2 = (5 * 100) / 2 = 250 N."
  },
  {
    "id": "physics7",
    "subject": "physics",
    "question": "A force F = (3i + 4j) N displaces a body by s = (2i + 5j) m. The work done by the force is:",
    "option1": "26 J",
    "option2": "14 J",
    "option3": "20 J",
    "option4": "6 J",
    "answer": "option1",
    "solution": "Work done W = F . s = (3*2) + (4*5) = 6 + 20 = 26 J."
  },
  {
    "id": "physics8",
    "subject": "physics",
    "question": "If the momentum of a body increases by 50%, its kinetic energy increases by:",
    "option1": "50%",
    "option2": "100%",
    "option3": "125%",
    "option4": "150%",
    "answer": "option3",
    "solution": "K = p^2 / (2m). New momentum p' = 1.5 p. New K' = (1.5 p)^2 / (2m) = 2.25 K. Percentage increase = (2.25 - 1)*100 = 125%."
  },
  {
    "id": "physics9",
    "subject": "physics",
    "question": "The moment of inertia of a uniform thin rod of mass M and length L about an axis passing through its center and perpendicular to its length is:",
    "option1": "ML^2 / 12",
    "option2": "ML^2 / 3",
    "option3": "ML^2 / 2",
    "option4": "ML^2 / 6",
    "answer": "option1",
    "solution": "Standard formula for moment of inertia of a rod about its central perpendicular axis is I = ML^2 / 12."
  },
  {
    "id": "physics10",
    "subject": "physics",
    "question": "A solid sphere and a hollow sphere of same mass and radius roll down an inclined plane without slipping. Which one reaches the bottom first?",
    "option1": "Hollow sphere",
    "option2": "Solid sphere",
    "option3": "Both reach at the same time",
    "option4": "Depends on the angle of inclination",
    "answer": "option2",
    "solution": "Acceleration down an incline is a = g*sin(theta) / (1 + k^2/R^2). For solid sphere k^2/R^2 = 2/5 = 0.4, for hollow sphere 2/3 = 0.67. Smaller k^2/R^2 gives greater acceleration, so solid sphere reaches first."
  },
  {
    "id": "physics11",
    "subject": "physics",
    "question": "The acceleration due to gravity at a height h above the Earth's surface (h << R) is given by:",
    "option1": "g' = g (1 - h/R)",
    "option2": "g' = g (1 - 2h/R)",
    "option3": "g' = g (1 + 2h/R)",
    "option4": "g' = g (1 - h^2/R^2)",
    "answer": "option2",
    "solution": "Using binomial approximation for h << R, g' = g / (1 + h/R)^2 approx g (1 - 2h/R)."
  },
  {
    "id": "physics12",
    "subject": "physics",
    "question": "The escape velocity from the surface of the Earth depends on the mass of the Earth (M) and its radius (R) as:",
    "option1": "sqrt(2GM/R)",
    "option2": "sqrt(GM/R)",
    "option3": "2GM/R",
    "option4": "sqrt(2GM R)",
    "answer": "option1",
    "solution": "Escape velocity is derived by equating initial kinetic energy to potential energy barrier: ve = sqrt(2GM/R)."
  },
  {
    "id": "physics13",
    "subject": "physics",
    "question": "Young's modulus of elasticity for a perfectly rigid body is:",
    "option1": "Zero",
    "option2": "1",
    "option3": "Infinite",
    "option4": "Negative",
    "answer": "option3",
    "solution": "For a perfectly rigid body, strain is zero for any stress. Young's modulus = Stress / Strain = Stress / 0 = Infinity."
  },
  {
    "id": "physics14",
    "subject": "physics",
    "question": "Terminal velocity of a spherical body falling through a viscous liquid is directly proportional to:",
    "option1": "Radius of the sphere (r)",
    "option2": "Square of the radius (r^2)",
    "option3": "Cube of the radius (r^3)",
    "option4": "Inverse of radius (1/r)",
    "answer": "option2",
    "solution": "By Stokes' Law, terminal velocity vt = (2/9) * r^2 * (rho - sigma) * g / eta. Thus vt is proportional to r^2."
  },
  {
    "id": "physics15",
    "subject": "physics",
    "question": "In a thermodynamic process, work done is zero in which of the following processes?",
    "option1": "Isobaric",
    "option2": "Isothermal",
    "option3": "Isochoric",
    "option4": "Adiabatic",
    "answer": "option3",
    "solution": "In an isochoric process, volume remains constant (dV = 0). Therefore, W = integral(P dV) = 0."
  },
  {
    "id": "physics16",
    "subject": "physics",
    "question": "An ideal heat engine operating between temperatures T1 (source) and T2 (sink) has an efficiency of:",
    "option1": "1 - T2/T1",
    "option2": "1 - T1/T2",
    "option3": "T2/T1",
    "option4": "T1/T2 - 1",
    "answer": "option1",
    "solution": "Carnot efficiency eta = 1 - Q2/Q1 = 1 - T2/T1 where T1 and T2 are absolute temperatures."
  },
  {
    "id": "physics17",
    "subject": "physics",
    "question": "The root mean square velocity (v_rms) of gas molecules at absolute temperature T is proportional to:",
    "option1": "T",
    "option2": "T^2",
    "option3": "sqrt(T)",
    "option4": "1/T",
    "answer": "option3",
    "solution": "v_rms = sqrt(3RT/M). Therefore, v_rms is directly proportional to sqrt(T)."
  },
  {
    "id": "physics18",
    "subject": "physics",
    "question": "The average kinetic energy per molecule of a monoatomic gas with degrees of freedom f = 3 is:",
    "option1": "(1/2) k_B T",
    "option2": "(3/2) k_B T",
    "option3": "(5/2) k_B T",
    "option4": "3 k_B T",
    "answer": "option2",
    "solution": "By law of equipartition of energy, energy per degree of freedom is (1/2) k_B T. For f = 3, total average KE = (3/2) k_B T."
  },
  {
    "id": "physics19",
    "subject": "physics",
    "question": "A simple pendulum has a time period T on Earth. If it is taken to a planet where acceleration due to gravity is 4g, its time period becomes:",
    "option1": "2 T",
    "option2": "T / 2",
    "option3": "T / 4",
    "option4": "4 T",
    "answer": "option2",
    "solution": "Time period T = 2*pi*sqrt(L/g). When g' = 4g, T' = 2*pi*sqrt(L/4g) = T/2."
  },
  {
    "id": "physics20",
    "subject": "physics",
    "question": "The equation of a simple harmonic wave is y = 0.05 sin(200 t - 2 x). What is the wave velocity?",
    "option1": "100 m/s",
    "option2": "200 m/s",
    "option3": "0.05 m/s",
    "option4": "400 m/s",
    "answer": "option1",
    "solution": "Wave velocity v = omega / k. Here omega = 200 rad/s and k = 2 rad/m. So v = 200 / 2 = 100 m/s."
  },
  {
    "id": "physics21",
    "subject": "physics",
    "question": "Two point charges +q and -q are separated by distance 2a. The electric dipole moment of the system is:",
    "option1": "2 q a",
    "option2": "q a",
    "option3": "zero",
    "option4": "q / (2a)",
    "answer": "option1",
    "solution": "Electric dipole moment magnitude p = magnitude of charge * separation = q * 2a = 2qa."
  },
  {
    "id": "physics22",
    "subject": "physics",
    "question": "The electric potential at a point due to a point charge Q varies with distance r as:",
    "option1": "1 / r^2",
    "option2": "1 / r",
    "option3": "r",
    "option4": "r^2",
    "answer": "option2",
    "solution": "Electric potential V = k Q / r, which is proportional to 1/r."
  },
  {
    "id": "physics23",
    "subject": "physics",
    "question": "Two metallic wires of same material have lengths in ratio 1:2 and radii in ratio 2:1. The ratio of their resistances is:",
    "option1": "1 : 8",
    "option2": "1 : 4",
    "option3": "8 : 1",
    "option4": "1 : 2",
    "answer": "option1",
    "solution": "R = rho * L / (pi * r^2). R1/R2 = (L1/L2) * (r2/r1)^2 = (1/2) * (1/2)^2 = (1/2) * (1/4) = 1/8."
  },
  {
    "id": "physics24",
    "subject": "physics",
    "question": "According to Kirchhoff's Loop Rule (second law), the algebraic sum of changes in potential around any closed loop is:",
    "option1": "Positive",
    "option2": "Negative",
    "option3": "Zero",
    "option4": "Equal to total current",
    "answer": "option3",
    "solution": "Kirchhoff's loop rule states that the algebraic sum of potential differences around any closed circuit loop must be zero."
  },
  {
    "id": "physics25",
    "subject": "physics",
    "question": "A long straight wire carrying current I produces a magnetic field B at distance r. If current is doubled and distance is halved, new magnetic field is:",
    "option1": "B",
    "option2": "2B",
    "option3": "4B",
    "option4": "8B",
    "answer": "option3",
    "solution": "B = (mu_0 * I) / (2 * pi * r). New field B' = (mu_0 * 2I) / (2 * pi * (r/2)) = 4 * B."
  },
  {
    "id": "physics26",
    "subject": "physics",
    "question": "The magnetic susceptibility of a paramagnetic material is:",
    "option1": "Small and negative",
    "option2": "Small and positive",
    "option3": "Large and positive",
    "option4": "Zero",
    "answer": "option2",
    "solution": "Paramagnetic materials have small positive magnetic susceptibility, whereas diamagnetic materials have small negative susceptibility."
  },
  {
    "id": "physics27",
    "subject": "physics",
    "question": "The magnitude of induced emf in a coil is proportional to:",
    "option1": "Magnetic flux",
    "option2": "Rate of change of magnetic flux",
    "option3": "Area of the coil only",
    "option4": "Resistance of coil",
    "answer": "option2",
    "solution": "According to Faraday's Law of EMI, induced emf e = -d(phi)/dt, which is proportional to the rate of change of magnetic flux."
  },
  {
    "id": "physics28",
    "subject": "physics",
    "question": "In an AC circuit containing only a pure capacitor, the current leads the voltage by a phase angle of:",
    "option1": "0 rad",
    "option2": "pi / 4 rad",
    "option3": "pi / 2 rad",
    "option4": "pi rad",
    "answer": "option3",
    "solution": "In a purely capacitive AC circuit, current leads voltage by 90 degrees or pi/2 radians."
  },
  {
    "id": "physics29",
    "subject": "physics",
    "question": "Which component of electromagnetic spectrum has the shortest wavelength?",
    "option1": "Microwaves",
    "option2": "Radio waves",
    "option3": "Gamma rays",
    "option4": "X-rays",
    "answer": "option3",
    "solution": "Gamma rays have the highest frequency and shortest wavelength in the electromagnetic spectrum."
  },
  {
    "id": "physics30",
    "subject": "physics",
    "question": "The speed of electromagnetic wave in vacuum is given by:",
    "option1": "1 / sqrt(mu_0 * epsilon_0)",
    "option2": "sqrt(mu_0 / epsilon_0)",
    "option3": "mu_0 * epsilon_0",
    "option4": "sqrt(mu_0 * epsilon_0)",
    "answer": "option1",
    "solution": "Maxwell showed that speed of light in vacuum c = 1 / sqrt(mu_0 * epsilon_0)."
  },
  {
    "id": "physics31",
    "subject": "physics",
    "question": "A convex lens of focal length 20 cm is placed in contact with a concave lens of focal length 20 cm. The power of the combination is:",
    "option1": "+5 D",
    "option2": "-5 D",
    "option3": "0 D",
    "option4": "+10 D",
    "answer": "option3",
    "solution": "P1 = 1/0.2 = +5 D, P2 = -1/0.2 = -5 D. Total power P = P1 + P2 = +5 - 5 = 0 D."
  },
  {
    "id": "physics32",
    "subject": "physics",
    "question": "In Young's double slit experiment, if slit separation is doubled and distance to screen is halved, fringe width becomes:",
    "option1": "4 times",
    "option2": "Double",
    "option3": "One-fourth",
    "option4": "Unchanged",
    "answer": "option3",
    "solution": "Fringe width beta = lambda * D / d. New beta' = lambda * (D/2) / (2d) = (1/4) beta."
  },
  {
    "id": "physics33",
    "subject": "physics",
    "question": "The de Broglie wavelength associated with an electron accelerated through potential difference V is proportional to:",
    "option1": "V",
    "option2": "sqrt(V)",
    "option3": "1 / sqrt(V)",
    "option4": "1 / V",
    "answer": "option3",
    "solution": "de Broglie wavelength lambda = h / sqrt(2 m e V). Therefore, lambda is proportional to 1/sqrt(V)."
  },
  {
    "id": "physics34",
    "subject": "physics",
    "question": "The minimum energy required to eject electrons from a metal surface is called its:",
    "option1": "Ionization potential",
    "option2": "Work function",
    "option3": "Excitation energy",
    "option4": "Binding energy",
    "answer": "option2",
    "solution": "Work function (Phi) is defined as the minimum energy of incident photon needed to liberate an electron from a metal surface."
  },
  {
    "id": "physics35",
    "subject": "physics",
    "question": "The ratio of radii of the first three Bohr orbits in hydrogen atom is:",
    "option1": "1 : 2 : 3",
    "option2": "1 : 4 : 9",
    "option3": "1 : 8 : 27",
    "option4": "1 : 3 : 5",
    "answer": "option2",
    "solution": "Radius of nth Bohr orbit r_n is proportional to n^2. For n = 1, 2, 3, ratio is 1^2 : 2^2 : 3^2 = 1 : 4 : 9."
  },
  {
    "id": "physics36",
    "subject": "physics",
    "question": "Two nuclei have mass numbers in ratio 1:8. The ratio of their nuclear radii is:",
    "option1": "1 : 2",
    "option2": "1 : 4",
    "option3": "1 : 8",
    "option4": "1 : 64",
    "answer": "option1",
    "solution": "Nuclear radius R = R0 * A^(1/3). R1/R2 = (A1/A2)^(1/3) = (1/8)^(1/3) = 1/2."
  },
  {
    "id": "physics37",
    "subject": "physics",
    "question": "In a p-n junction diode under reverse bias, current flows mainly due to:",
    "option1": "Majority carriers",
    "option2": "Minority carriers",
    "option3": "Electrons only",
    "option4": "Holes only",
    "answer": "option2",
    "solution": "Under reverse bias, barrier height increases, preventing majority carrier flow. The small reverse saturation current is due to minority carriers."
  },
  {
    "id": "physics38",
    "subject": "physics",
    "question": "For a transistor, the relation between current gains beta (CE) and alpha (CB) is:",
    "option1": "beta = alpha / (1 - alpha)",
    "option2": "alpha = beta / (1 - beta)",
    "option3": "beta = alpha / (1 + alpha)",
    "option4": "beta * alpha = 1",
    "answer": "option1",
    "solution": "Since IE = IB + IC, dividing by IC gives 1/alpha = 1/beta + 1 => beta = alpha / (1 - alpha)."
  },
  {
    "id": "physics39",
    "subject": "physics",
    "question": "In a Vernier Callipers, 10 vernier scale divisions coincide with 9 main scale divisions (1 MSD = 1 mm). Least count is:",
    "option1": "0.1 cm",
    "option2": "0.01 cm",
    "option3": "0.001 cm",
    "option4": "1 cm",
    "answer": "option2",
    "solution": "LC = 1 MSD - 1 VSD = 1 mm - 0.9 mm = 0.1 mm = 0.01 cm."
  },
  {
    "id": "physics40",
    "subject": "physics",
    "question": "A meter bridge is used to measure an unknown resistance using the principle of:",
    "option1": "Wheatstone bridge",
    "option2": "Potentiometer",
    "option3": "Ohm's law",
    "option4": "Faraday's law",
    "answer": "option1",
    "solution": "A meter bridge is a practical application of the Wheatstone bridge principle for measuring unknown resistance."
  },
  {
    "id": "physics41",
    "subject": "physics",
    "question": "Dimensional formula of magnetic flux density (magnetic field B) is:",
    "option1": "[M L^0 T^-2 A^-1]",
    "option2": "[M L T^-2 A^-1]",
    "option3": "[M L^2 T^-2 A^-1]",
    "option4": "[M L T^-1 A^-2]",
    "answer": "option1",
    "solution": "F = q v B => B = F / (q v) = [M L T^-2] / ([A T] * [L T^-1]) = [M L^0 T^-2 A^-1]."
  },
  {
    "id": "physics42",
    "subject": "physics",
    "question": "A body is dropped from top of a tower of height H. Time taken to reach ground is:",
    "option1": "sqrt(H / g)",
    "option2": "sqrt(2H / g)",
    "option3": "2H / g",
    "option4": "H / 2g",
    "answer": "option2",
    "solution": "Using H = u t + (1/2) g t^2 with u = 0 gives H = (1/2) g t^2 => t = sqrt(2H/g)."
  },
  {
    "id": "physics43",
    "subject": "physics",
    "question": "A horizontal force of 20 N just moves a block of mass 4 kg on a rough floor. Coefficient of static friction is (g = 10 m/s^2):",
    "option1": "0.2",
    "option2": "0.5",
    "option3": "0.8",
    "option4": "0.25",
    "answer": "option2",
    "solution": "Limiting friction fs = mu_s * N = mu_s * m * g. 20 = mu_s * 4 * 10 => mu_s = 20 / 40 = 0.5."
  },
  {
    "id": "physics44",
    "subject": "physics",
    "question": "When a spring is stretched by x, stored potential energy is E. If it is stretched by 3x, potential energy becomes:",
    "option1": "3 E",
    "option2": "6 E",
    "option3": "9 E",
    "option4": "12 E",
    "answer": "option3",
    "solution": "U = (1/2) k x^2. For extension 3x, U' = (1/2) k (3x)^2 = 9 * (1/2) k x^2 = 9 E."
  },
  {
    "id": "physics45",
    "subject": "physics",
    "question": "The angular momentum of a rotating body is conserved when external:",
    "option1": "Force is zero",
    "option2": "Torque is zero",
    "option3": "Work is zero",
    "option4": "Power is zero",
    "answer": "option2",
    "solution": "dL/dt = Tau_ext. If net external torque Tau_ext = 0, angular momentum L remains constant."
  },
  {
    "id": "physics46",
    "subject": "physics",
    "question": "At what height above Earth surface does acceleration due to gravity become g/4? (R = radius of Earth)",
    "option1": "R / 2",
    "option2": "R",
    "option3": "2 R",
    "option4": "sqrt(2) R",
    "answer": "option2",
    "solution": "g' = g * [R / (R + h)]^2. Given g' = g/4 => R / (R + h) = 1/2 => R + h = 2R => h = R."
  },
  {
    "id": "physics47",
    "subject": "physics",
    "question": "According to Bernoulli's theorem, for streamlined flow of ideal fluid, total energy per unit mass is constant. It includes:",
    "option1": "Pressure energy, kinetic energy, potential energy",
    "option2": "Kinetic energy and potential energy only",
    "option3": "Heat energy and kinetic energy",
    "option4": "Pressure energy and thermal energy",
    "answer": "option1",
    "solution": "Bernoulli's equation states P/rho + v^2/2 + gh = constant, which sums pressure, kinetic, and potential energies per unit mass."
  },
  {
    "id": "physics48",
    "subject": "physics",
    "question": "In an adiabatic process, relation between pressure P and volume V for an ideal gas is:",
    "option1": "P V = constant",
    "option2": "P V^gamma = constant",
    "option3": "P^gamma V = constant",
    "option4": "P / V = constant",
    "answer": "option2",
    "solution": "For reversible adiabatic process, P V^gamma = constant, where gamma = Cp/Cv."
  },
  {
    "id": "physics49",
    "subject": "physics",
    "question": "Two simple harmonic motions are y1 = 3 sin(omega t) and y2 = 4 cos(omega t). Resultant amplitude is:",
    "option1": "7",
    "option2": "1",
    "option3": "5",
    "option4": "12",
    "answer": "option3",
    "solution": "y2 can be written as 4 sin(omega t + pi/2). Phase difference is 90 deg. Resultant A = sqrt(A1^2 + A2^2) = sqrt(3^2 + 4^2) = 5."
  },
  {
    "id": "physics50",
    "subject": "physics",
    "question": "Equipotential surfaces around an isolated positive point charge are:",
    "option1": "Concentric spheres",
    "option2": "Parallel planes",
    "option3": "Coaxial cylinders",
    "option4": "Paraboloids",
    "answer": "option1",
    "solution": "Electric potential V = k Q / r is constant for fixed r, making equipotential surfaces concentric spheres centered at the charge."
  },
  {
    "id": "physics51",
    "subject": "physics",
    "question": "The internal resistance of a cell of emf E is r. When connected across external resistance R = r, potential difference across cell terminals is:",
    "option1": "E",
    "option2": "E / 2",
    "option3": "E / 4",
    "option4": "2 E",
    "answer": "option2",
    "solution": "Current I = E / (R + r) = E / (2r). Terminal potential V = I * R = (E / 2r) * r = E / 2."
  },
  {
    "id": "physics52",
    "subject": "physics",
    "question": "A charged particle moves with velocity v perpendicular to magnetic field B. Radius of circular path is:",
    "option1": "m v / (q B)",
    "option2": "q B / (m v)",
    "option3": "m q / (v B)",
    "option4": "v B / (m q)",
    "answer": "option1",
    "solution": "Centripetal force equals magnetic force: m v^2 / r = q v B => r = m v / (q B)."
  },
  {
    "id": "physics53",
    "subject": "physics",
    "question": "The resonant frequency of a series LCR circuit is:",
    "option1": "1 / (2 pi sqrt(L C))",
    "option2": "2 pi sqrt(L C)",
    "option3": "sqrt(L C) / (2 pi)",
    "option4": "1 / (L C)",
    "answer": "option1",
    "solution": "Resonance occurs when XL = XC => omega L = 1/(omega C) => f = 1 / (2 pi sqrt(LC))."
  },
  {
    "id": "physics54",
    "subject": "physics",
    "question": "The phenomenon of polarization proves that light waves are:",
    "option1": "Longitudinal",
    "option2": "Transverse",
    "option3": "Mechanical",
    "option4": "Stationary",
    "answer": "option2",
    "solution": "Polarization occurs only in transverse waves, proving light is a transverse wave."
  },
  {
    "id": "physics55",
    "subject": "physics",
    "question": "Critical angle for a medium is 30 degrees. The refractive index of the medium is:",
    "option1": "1.5",
    "option2": "2.0",
    "option3": "1.33",
    "option4": "1.73",
    "answer": "option2",
    "solution": "mu = 1 / sin(ic) = 1 / sin(30 deg) = 1 / 0.5 = 2.0."
  },
  {
    "id": "physics56",
    "subject": "physics",
    "question": "Stopping potential in a photoelectric experiment depends on:",
    "option1": "Frequency of incident light only",
    "option2": "Intensity of incident light only",
    "option3": "Both frequency and work function of metal",
    "option4": "Distance of source only",
    "answer": "option3",
    "solution": "e V0 = h nu - Phi. Stopping potential V0 depends on photon frequency nu and metal work function Phi."
  },
  {
    "id": "physics57",
    "subject": "physics",
    "question": "The half-life of a radioactive substance is 10 days. The fraction left undecayed after 30 days is:",
    "option1": "1 / 2",
    "option2": "1 / 4",
    "option3": "1 / 8",
    "option4": "1 / 16",
    "answer": "option3",
    "solution": "Number of half-lives n = 30 / 10 = 3. Remaining fraction = (1/2)^3 = 1/8."
  },
  {
    "id": "physics58",
    "subject": "physics",
    "question": "In a NOR gate, output is HIGH (1) only when:",
    "option1": "All inputs are HIGH",
    "option2": "All inputs are LOW",
    "option3": "Any one input is HIGH",
    "option4": "Inputs are different",
    "answer": "option2",
    "solution": "NOR gate output Y = NOT(A OR B). Y is 1 only when A = 0 and B = 0."
  },
  {
    "id": "physics59",
    "subject": "physics",
    "question": "In a Sonometer experiment, frequency of vibration of stretched string is inversely proportional to:",
    "option1": "Square root of tension",
    "option2": "Length of string",
    "option3": "Diameter squared",
    "option4": "Mass only",
    "answer": "option2",
    "solution": "Law of length for sonometer: fundamental frequency f = (1 / 2L) * sqrt(T / m), so f is inversely proportional to L."
  },
  {
    "id": "physics60",
    "subject": "physics",
    "question": "Dimensions of universal gravitational constant G are:",
    "option1": "[M^-1 L^3 T^-2]",
    "option2": "[M L^3 T^-2]",
    "option3": "[M^-2 L^2 T^-1]",
    "option4": "[M^-1 L^2 T^-2]",
    "answer": "option1",
    "solution": "F = G m1 m2 / r^2 => G = F r^2 / m^2 = [M L T^-2][L^2] / [M^2] = [M^-1 L^3 T^-2]."
  },
  {
    "id": "physics61",
    "subject": "physics",
    "question": "Vector cross product A x B is equal to:",
    "option1": "B x A",
    "option2": "- (B x A)",
    "option3": "|A||B| cos(theta)",
    "option4": "Zero always",
    "answer": "option2",
    "solution": "Vector product is anti-commutative: A x B = - (B x A)."
  },
  {
    "id": "physics62",
    "subject": "physics",
    "question": "A body starts from rest with uniform acceleration 'a'. Distance covered in nth second is given by:",
    "option1": "(a / 2) (2n - 1)",
    "option2": "a (n - 1)",
    "option3": "(a / 2) (n^2 - 1)",
    "option4": "a n / 2",
    "answer": "option1",
    "solution": "Sn = u + (a/2)(2n - 1). Since u = 0, Sn = (a/2)(2n - 1)."
  },
  {
    "id": "physics63",
    "subject": "physics",
    "question": "A swimmer can swim at 4 km/h in still water. If river flow velocity is 3 km/h, shortest time to cross river of width 1 km is:",
    "option1": "15 min",
    "option2": "20 min",
    "option3": "12 min",
    "option4": "30 min",
    "answer": "option1",
    "solution": "To cross in minimum time, swimmer heads perpendicular to current. t_min = width / v_swimmer = 1 / 4 h = 15 minutes."
  },
  {
    "id": "physics64",
    "subject": "physics",
    "question": "An elevator of mass 1000 kg moves upward with acceleration 2 m/s^2. Tension in supporting cable is (g = 10 m/s^2):",
    "option1": "10000 N",
    "option2": "12000 N",
    "option3": "8000 N",
    "option4": "2000 N",
    "answer": "option2",
    "solution": "T - mg = ma => T = m(g + a) = 1000 * (10 + 2) = 12000 N."
  },
  {
    "id": "physics65",
    "subject": "physics",
    "question": "A machine gun fires 20 bullets per second, each of mass 10 g with velocity 500 m/s. Force needed to hold gun in position is:",
    "option1": "100 N",
    "option2": "50 N",
    "option3": "200 N",
    "option4": "500 N",
    "answer": "option1",
    "solution": "F = n * m * v = 20 * (0.010 kg) * 500 m/s = 100 N."
  },
  {
    "id": "physics66",
    "subject": "physics",
    "question": "A force F = -k x (where k is positive constant) acting on a particle represents:",
    "option1": "Non-conservative force",
    "option2": "Conservative restoring force",
    "option3": "Frictional force",
    "option4": "Centripetal force",
    "answer": "option2",
    "solution": "F = -kx is Hooke's law, representing a conservative restoring force responsible for Simple Harmonic Motion."
  },
  {
    "id": "physics67",
    "subject": "physics",
    "question": "The work done by a conservative force along a closed path is:",
    "option1": "Always positive",
    "option2": "Always negative",
    "option3": "Zero",
    "option4": "Depends on path length",
    "answer": "option3",
    "solution": "By definition, work done by any conservative force around any closed loop is identically zero."
  },
  {
    "id": "physics68",
    "subject": "physics",
    "question": "A thin circular ring of mass M and radius R rotates about its central axis. Its radius of gyration K is:",
    "option1": "R",
    "option2": "R / sqrt(2)",
    "option3": "R / 2",
    "option4": "2 R",
    "answer": "option1",
    "solution": "I = M K^2. For ring about central axis, I = M R^2. Thus K = R."
  },
  {
    "id": "physics69",
    "subject": "physics",
    "question": "A planet moves in an elliptical orbit around Sun. Kepler's second law (law of areas) is a consequence of conservation of:",
    "option1": "Linear momentum",
    "option2": "Angular momentum",
    "option3": "Energy",
    "option4": "Mass",
    "answer": "option2",
    "solution": "Areal velocity dA/dt = L / (2m). Constant areal velocity implies conservation of angular momentum L."
  },
  {
    "id": "physics70",
    "subject": "physics",
    "question": "Two soap bubbles of radii 2 cm and 3 cm coalesce under isothermal conditions in vacuum. Radius of new bubble is:",
    "option1": "5 cm",
    "option2": "sqrt(13) cm",
    "option3": "1 cm",
    "option4": "2.5 cm",
    "answer": "option2",
    "solution": "In vacuum, energy conservation gives surface area equality: 4*pi*r1^2 + 4*pi*r2^2 = 4*pi*R^2 => R = sqrt(r1^2 + r2^2) = sqrt(2^2 + 3^2) = sqrt(13) cm."
  },
  {
    "id": "physics71",
    "subject": "physics",
    "question": "Specific heat capacity of a substance during an isothermal process is:",
    "option1": "Zero",
    "option2": "Finite and positive",
    "option3": "Infinite",
    "option4": "Negative",
    "answer": "option3",
    "solution": "c = Q / (m * dT). In isothermal process dT = 0, so c = Q / 0 = Infinity."
  },
  {
    "id": "physics72",
    "subject": "physics",
    "question": "Ratio of specific heats gamma = Cp / Cv for a diatomic gas (ignoring vibrational modes) is:",
    "option1": "5 / 3",
    "option2": "7 / 5",
    "option3": "4 / 3",
    "option4": "9 / 7",
    "answer": "option2",
    "solution": "For diatomic gas, f = 5. Cv = 5R/2, Cp = 7R/2. gamma = Cp/Cv = 7/5 = 1.4."
  },
  {
    "id": "physics73",
    "subject": "physics",
    "question": "At what temperature does the velocity of sound in air become double its value at 0 degree C?",
    "option1": "273 K",
    "option2": "546 K",
    "option3": "1092 K",
    "option4": "819 K",
    "answer": "option3",
    "solution": "v is proportional to sqrt(T). v'/v = sqrt(T'/273) = 2 => T'/273 = 4 => T' = 1092 K."
  },
  {
    "id": "physics74",
    "subject": "physics",
    "question": "The fundamental frequency of an open organ pipe of length L is f. If one end is closed, fundamental frequency becomes:",
    "option1": "f / 2",
    "option2": "2 f",
    "option3": "f",
    "option4": "3 f",
    "answer": "option1",
    "solution": "Open pipe f_open = v / (2L). Closed pipe f_closed = v / (4L) = f_open / 2."
  },
  {
    "id": "physics75",
    "subject": "physics",
    "question": "Two equal positive charges Q are placed at distance 2r. Electric field intensity at midpoint of line joining them is:",
    "option1": "k Q / r^2",
    "option2": "2 k Q / r^2",
    "option3": "Zero",
    "option4": "4 k Q / r^2",
    "answer": "option3",
    "solution": "Electric fields due to equal charges at equal distances point in opposite directions, canceling out to zero."
  },
  {
    "id": "physics76",
    "subject": "physics",
    "question": "Three capacitors each of capacitance C are connected in series. Equivalent capacitance of combination is:",
    "option1": "3 C",
    "option2": "C / 3",
    "option3": "C / 2",
    "option4": "2 C / 3",
    "answer": "option2",
    "solution": "1/Ceq = 1/C + 1/C + 1/C = 3/C => Ceq = C / 3."
  },
  {
    "id": "physics77",
    "subject": "physics",
    "question": "Drift velocity v_d of free electrons in a conductor varies with applied electric field E as:",
    "option1": "v_d proportional to E",
    "option2": "v_d proportional to 1/E",
    "option3": "v_d proportional to E^2",
    "option4": "v_d independent of E",
    "answer": "option1",
    "solution": "v_d = (e * E * tau) / m, which shows drift velocity is directly proportional to applied electric field E."
  },
  {
    "id": "physics78",
    "subject": "physics",
    "question": "A Wheatstone bridge is balanced when four arm resistances are R1, R2, R3, R4. The balancing condition is:",
    "option1": "R1 * R2 = R3 * R4",
    "option2": "R1 / R2 = R3 / R4",
    "option3": "R1 + R2 = R3 + R4",
    "option4": "R1 / R4 = R3 / R2",
    "answer": "option2",
    "solution": "Standard Wheatstone bridge balance condition is R1 / R2 = R3 / R4."
  },
  {
    "id": "physics79",
    "subject": "physics",
    "question": "Work done in rotating a magnetic dipole of dipole moment M through angle theta from direction of uniform field B is:",
    "option1": "M B sin(theta)",
    "option2": "M B (1 - cos(theta))",
    "option3": "M B cos(theta)",
    "option4": "- M B cos(theta)",
    "answer": "option2",
    "solution": "W = integral from 0 to theta of (M B sin(theta) d theta) = M B (1 - cos(theta))."
  },
  {
    "id": "physics80",
    "subject": "physics",
    "question": "A transformer steps up voltage from 110 V to 220 V. If primary current is 4 A (ideal transformer), secondary current is:",
    "option1": "8 A",
    "option2": "2 A",
    "option3": "4 A",
    "option4": "1 A",
    "answer": "option2",
    "solution": "For ideal transformer Vp * Ip = Vs * Is => 110 * 4 = 220 * Is => Is = 2 A."
  },
  {
    "id": "physics81",
    "subject": "physics",
    "question": "Displacement current arises due to time-varying:",
    "option1": "Electric field",
    "option2": "Magnetic field",
    "option3": "Conduction current",
    "option4": "Gravitational field",
    "answer": "option1",
    "solution": "Maxwell introduced displacement current Id = epsilon_0 * (d Phi_E / dt), caused by time-varying electric flux/field."
  },
  {
    "id": "physics82",
    "subject": "physics",
    "question": "In total internal reflection, light travels from:",
    "option1": "Rarer to denser medium",
    "option2": "Denser to rarer medium",
    "option3": "Air to water only",
    "option4": "Vacuum to glass only",
    "answer": "option2",
    "solution": "Total internal reflection occurs only when light propagates from optically denser to optically rarer medium at angle greater than critical angle."
  },
  {
    "id": "physics83",
    "subject": "physics",
    "question": "The magnifying power of a simple microscope (magnifying glass) for normal vision (near point D) is:",
    "option1": "1 + D/f",
    "option2": "D / f",
    "option3": "f / D",
    "option4": "1 + f/D",
    "answer": "option1",
    "solution": "For image at least distance of distinct vision D, angular magnification M = 1 + D/f."
  },
  {
    "id": "physics84",
    "subject": "physics",
    "question": "According to Einstein's photoelectric equation, maximum kinetic energy of emitted photoelectrons depends linearly on:",
    "option1": "Intensity of incident light",
    "option2": "Frequency of incident light",
    "option3": "Time of exposure",
    "option4": "Velocity of incident photons",
    "answer": "option2",
    "solution": "K_max = h * nu - Phi. Max KE increases linearly with photon frequency nu above threshold frequency."
  },
  {
    "id": "physics85",
    "subject": "physics",
    "question": "The wavelength of first line of Balmer series in Hydrogen spectrum is 6563 Angstroms. The series lies in:",
    "option1": "Ultraviolet region",
    "option2": "Visible region",
    "option3": "Infrared region",
    "option4": "X-ray region",
    "answer": "option2",
    "solution": "Balmer series lines fall in the visible region of the electromagnetic spectrum."
  },
  {
    "id": "physics86",
    "subject": "physics",
    "question": "Nuclear fusion reaction takes place at extremely high temperature because:",
    "option1": "Atoms get ionized",
    "option2": "Kinetic energy must overcome electrostatic repulsion between nuclei",
    "option3": "Molecules break down",
    "option4": "Neutrons are produced",
    "answer": "option2",
    "solution": "Positively charged nuclei require high thermal kinetic energy to overcome Coulomb repulsive barrier and fuse."
  },
  {
    "id": "physics87",
    "subject": "physics",
    "question": "Width of depletion region in a p-n junction diode under forward bias:",
    "option1": "Increases",
    "option2": "Decreases",
    "option3": "Remains unchanged",
    "option4": "Becomes infinite",
    "answer": "option2",
    "solution": "Forward bias opposes built-in potential, reducing barrier height and narrowing the depletion width."
  },
  {
    "id": "physics88",
    "subject": "physics",
    "question": "An ideal LED emits light when it is:",
    "option1": "Forward biased",
    "option2": "Reverse biased",
    "option3": "Unbiased",
    "option4": "Breakdown region",
    "answer": "option1",
    "solution": "Light Emitting Diodes (LEDs) emit light via electron-hole recombination when operated under forward bias."
  },
  {
    "id": "physics89",
    "subject": "physics",
    "question": "In Screw Gauge, zero error is positive when zero of circular scale lies:",
    "option1": "Above reference line",
    "option2": "Below reference line",
    "option3": "Coinciding with reference line",
    "option4": "Opposite to main scale",
    "answer": "option2",
    "solution": "When studs are in contact, if zero of circular scale remains below index/reference line, zero error is positive."
  },
  {
    "id": "physics90",
    "subject": "physics",
    "question": "A multimeter cannot be directly used to measure:",
    "option1": "AC Voltage",
    "option2": "DC Current",
    "option3": "Electrical Resistance",
    "option4": "Magnetic Flux",
    "answer": "option4",
    "solution": "Standard multimeters measure voltage, current, and resistance, but not magnetic flux directly."
  },
  {
    "id": "physics91",
    "subject": "physics",
    "question": "The angle between velocity vector and acceleration vector in uniform circular motion is:",
    "option1": "0 degrees",
    "option2": "45 degrees",
    "option3": "90 degrees",
    "option4": "180 degrees",
    "answer": "option3",
    "solution": "In uniform circular motion, velocity vector is tangential and centripetal acceleration is radial (inward), making angle 90 degrees."
  },
  {
    "id": "physics92",
    "subject": "physics",
    "question": "Momentum of a photon of frequency nu is given by:",
    "option1": "h nu / c",
    "option2": "h c / nu",
    "option3": "h nu",
    "option4": "h / (nu c)",
    "answer": "option1",
    "solution": "Photon energy E = h nu. Momentum p = E / c = h nu / c."
  },
  {
    "id": "physics93",
    "subject": "physics",
    "question": "Bulk modulus of elasticity for an incompressible liquid is:",
    "option1": "Zero",
    "option2": "1",
    "option3": "Infinite",
    "option4": "Negative",
    "answer": "option3",
    "solution": "For incompressible liquid, change in volume dV = 0. Bulk modulus B = -V (dP/dV) = Infinity."
  },
  {
    "id": "physics94",
    "subject": "physics",
    "question": "The time period of a simple pendulum inside a freely falling elevator is:",
    "option1": "Zero",
    "option2": "Infinite",
    "option3": "Same as ground",
    "option4": "2 seconds",
    "answer": "option2",
    "solution": "In free fall, effective g_eff = g - g = 0. T = 2*pi*sqrt(L/0) = Infinity."
  },
  {
    "id": "physics95",
    "subject": "physics",
    "question": "Self-inductance L of a long solenoid of length l, cross-sectional area A and N turns is:",
    "option1": "mu_0 N^2 A / l",
    "option2": "mu_0 N A / l",
    "option3": "mu_0 N^2 A l",
    "option4": "mu_0 N A l^2",
    "answer": "option1",
    "solution": "L = mu_0 * n^2 * A * l = mu_0 * (N/l)^2 * A * l = mu_0 * N^2 * A / l."
  },
  {
    "id": "physics96",
    "subject": "physics",
    "question": "Brewster's angle ip for glass of refractive index mu = 1.732 (sqrt(3)) is:",
    "option1": "30 degrees",
    "option2": "45 degrees",
    "option3": "60 degrees",
    "option4": "90 degrees",
    "answer": "option3",
    "solution": "Brewster's law: tan(ip) = mu = sqrt(3) => ip = arctan(sqrt(3)) = 60 degrees."
  },
  {
    "id": "physics97",
    "subject": "physics",
    "question": "If energy E, velocity V, and time T are chosen as fundamental units, dimensional formula of mass is:",
    "option1": "[E V^-2 T^0]",
    "option2": "[E V^-1 T^0]",
    "option3": "[E V^2 T^-1]",
    "option4": "[E V T^-2]",
    "answer": "option1",
    "solution": "E = M V^2 => M = E V^-2 = [E V^-2 T^0]."
  },
  {
    "id": "physics98",
    "subject": "physics",
    "question": "Work done in charging a capacitor of capacitance C to potential V is stored as electrostatic potential energy equal to:",
    "option1": "C V",
    "option2": "(1/2) C V^2",
    "option3": "C V^2",
    "option4": "(1/2) C^2 V",
    "answer": "option2",
    "solution": "U = integral of q dq / C = (1/2) Q^2 / C = (1/2) C V^2."
  },
  {
    "id": "physics99",
    "subject": "physics",
    "question": "Which logic gate is known as a Universal Gate?",
    "option1": "AND gate",
    "option2": "OR gate",
    "option3": "NAND gate",
    "option4": "XOR gate",
    "answer": "option3",
    "solution": "NAND and NOR gates are called universal gates because any logic function can be realized using only these gates."
  },
  {
    "id": "physics100",
    "subject": "physics",
    "question": "In Resonance Tube experiment, first resonance occurs at length L1 = 15 cm and second at L2 = 47 cm. End correction is:",
    "option1": "1 cm",
    "option2": "2 cm",
    "option3": "0.5 cm",
    "option4": "1.5 cm",
    "answer": "option1",
    "solution": "End correction e = (L2 - 3*L1) / 2 = (47 - 3*15) / 2 = (47 - 45) / 2 = 1 cm."
  },




  {
    "id": "chemistry1",
    "subject": "chemistry",
    "question": "What is the molarity of a solution containing 4.0 g of NaOH dissolved in enough water to make 250 mL of solution?",
    "option1": "0.1 M",
    "option2": "0.2 M",
    "option3": "0.4 M",
    "option4": "0.5 M",
    "answer": "option3",
    "solution": "Molar mass of NaOH = 40 g/mol. Moles of NaOH = 4.0 / 40 = 0.1 mol. Volume of solution = 250 mL = 0.25 L. Molarity = Moles / Volume (L) = 0.1 / 0.25 = 0.4 M."
  },
  {
    "id": "chemistry2",
    "subject": "chemistry",
    "question": "How many moles of hydrogen atoms are present in 1.8 grams of water (H2O)?",
    "option1": "0.1 mol",
    "option2": "0.2 mol",
    "option3": "0.5 mol",
    "option4": "1.0 mol",
    "answer": "option2",
    "solution": "Molar mass of H2O = 18 g/mol. Moles of H2O = 1.8 / 18 = 0.1 mol. Since 1 mole of H2O contains 2 moles of H atoms, moles of H atoms = 0.1 x 2 = 0.2 mol."
  },
  {
    "id": "chemistry3",
    "subject": "chemistry",
    "question": "The empirical formula of a compound is CH2O and its molar mass is 180 g/mol. What is its molecular formula?",
    "option1": "C2H4O2",
    "option2": "C3H6O3",
    "option3": "C6H12O6",
    "option4": "C5H10O5",
    "answer": "option3",
    "solution": "Empirical formula mass = 12 + 2(1) + 16 = 30 g/mol. Factor n = Molar mass / Empirical mass = 180 / 30 = 6. Molecular formula = (CH2O)6 = C6H12O6."
  },
  {
    "id": "chemistry4",
    "subject": "chemistry",
    "question": "Which of the following contains the maximum number of molecules?",
    "option1": "7 g N2",
    "option2": "2 g H2",
    "option3": "16 g O2",
    "option4": "44 g CO2",
    "answer": "option2",
    "solution": "Moles of N2 = 7/28 = 0.25. Moles of H2 = 2/2 = 1.0. Moles of O2 = 16/32 = 0.5. Moles of CO2 = 44/44 = 1.0. Maximum moles of molecules = H2 (1 mol) and CO2 (1 mol), but 2 g H2 has 1 mole = 6.022 x 10^23 molecules."
  },
  {
    "id": "chemistry5",
    "subject": "chemistry",
    "question": "What is the mass percent of carbon in methane (CH4)?",
    "option1": "25%",
    "option2": "50%",
    "option3": "75%",
    "option4": "80%",
    "answer": "option3",
    "solution": "Molar mass of CH4 = 12 + 4 = 16 g/mol. Mass percent of C = (12 / 16) x 100 = 75%."
  },
  {
    "id": "chemistry6",
    "subject": "chemistry",
    "question": "How many quantum numbers are required to define an electron in an atom completely?",
    "option1": "1",
    "option2": "2",
    "option3": "3",
    "option4": "4",
    "answer": "option4",
    "solution": "Four quantum numbers (n, l, ml, ms) are required to specify the energy, orbital shape, orientation, and spin direction of an electron."
  },
  {
    "id": "chemistry7",
    "subject": "chemistry",
    "question": "The principal quantum number n = 3 corresponds to which shell?",
    "option1": "K shell",
    "option2": "L shell",
    "option3": "M shell",
    "option4": "N shell",
    "answer": "option3",
    "solution": "Shell designations are n=1 (K), n=2 (L), n=3 (M), and n=4 (N)."
  },
  {
    "id": "chemistry8",
    "subject": "chemistry",
    "question": "What is the maximum number of electrons that can be accommodated in a subshell with l = 2?",
    "option1": "2",
    "option2": "6",
    "option3": "10",
    "option4": "14",
    "answer": "option3",
    "solution": "Subshell with l = 2 is the d-subshell. Maximum capacity = 2(2l + 1) = 2(2*2 + 1) = 10 electrons."
  },
  {
    "id": "chemistry9",
    "subject": "chemistry",
    "question": "Which transition in hydrogen spectrum corresponds to the visible region?",
    "option1": "Lyman series",
    "option2": "Balmer series",
    "option3": "Paschen series",
    "option4": "Brackett series",
    "answer": "option2",
    "solution": "The Balmer series falls within the visible region of the electromagnetic spectrum."
  },
  {
    "id": "chemistry10",
    "subject": "chemistry",
    "question": "According to de Broglie, the wavelength associated with a particle of mass m moving with velocity v is given by:",
    "option1": "λ = h / mv",
    "option2": "λ = mv / h",
    "option3": "λ = h * mv",
    "option4": "λ = h / m",
    "answer": "option1",
    "solution": "De Broglie equation states λ = h / p = h / mv."
  },
  {
    "id": "chemistry11",
    "subject": "chemistry",
    "question": "Which molecule has a linear geometry?",
    "option1": "H2O",
    "option2": "SO2",
    "option3": "BeCl2",
    "option4": "NH3",
    "answer": "option3",
    "solution": "BeCl2 undergoes sp hybridization and forms a linear molecule with a 180° bond angle."
  },
  {
    "id": "chemistry12",
    "subject": "chemistry",
    "question": "What is the hybridization of the central atom in SF6?",
    "option1": "sp3",
    "option2": "sp3d",
    "option3": "sp3d2",
    "option4": "dsp2",
    "answer": "option3",
    "solution": "SF6 has 6 bonding pairs around sulfur and zero lone pairs, giving octahedral geometry with sp3d2 hybridization."
  },
  {
    "id": "chemistry13",
    "subject": "chemistry",
    "question": "According to Molecular Orbital Theory, which of the following species is paramagnetic?",
    "option1": "N2",
    "option2": "O2",
    "option3": "C2",
    "option4": "F2",
    "answer": "option2",
    "solution": "O2 contains two unpaired electrons in its anti-bonding π*2px and π*2py orbitals, making it paramagnetic."
  },
  {
    "id": "chemistry14",
    "subject": "chemistry",
    "question": "What is the bond order of the O2+ ion?",
    "option1": "1.5",
    "option2": "2.0",
    "option3": "2.5",
    "option4": "3.0",
    "answer": "option3",
    "solution": "O2 has 16 electrons (Bond order = 2). O2+ has 15 electrons; removing an anti-bonding electron increases bond order to (10 - 5)/2 = 2.5."
  },
  {
    "id": "chemistry15",
    "subject": "chemistry",
    "question": "Which of the following molecules possesses the strongest hydrogen bonding?",
    "option1": "HF",
    "option2": "H2O",
    "option3": "NH3",
    "option4": "HCl",
    "answer": "option1",
    "solution": "Fluorine is the most electronegative element, making the H-F bond highly polar and giving HF the strongest individual hydrogen bonds."
  },
  {
    "id": "chemistry16",
    "subject": "chemistry",
    "question": "For an isolated system undergoing a spontaneous process, the change in entropy (ΔS) is:",
    "option1": "Zero",
    "option2": "Greater than zero",
    "option3": "Less than zero",
    "option4": "Constant",
    "answer": "option2",
    "solution": "According to the Second Law of Thermodynamics, the total entropy of an isolated system increases (ΔS > 0) during a spontaneous process."
  },
  {
    "id": "chemistry17",
    "subject": "chemistry",
    "question": "Which of the following is an intensive property?",
    "option1": "Volume",
    "option2": "Mass",
    "option3": "Enthalpy",
    "option4": "Temperature",
    "answer": "option4",
    "solution": "Temperature does not depend on the quantity or size of matter present, making it an intensive property."
  },
  {
    "id": "chemistry18",
    "subject": "chemistry",
    "question": "For an endothermic reaction, ΔH is:",
    "option1": "Positive",
    "option2": "Negative",
    "option3": "Zero",
    "option4": "Unpredictable",
    "answer": "option1",
    "solution": "Endothermic reactions absorb heat from surroundings, so heat content increases (ΔH > 0)."
  },
  {
    "id": "chemistry19",
    "subject": "chemistry",
    "question": "The condition for a reaction to be spontaneous at all temperatures is:",
    "option1": "ΔH > 0 and ΔS > 0",
    "option2": "ΔH < 0 and ΔS > 0",
    "option3": "ΔH < 0 and ΔS < 0",
    "option4": "ΔH > 0 and ΔS < 0",
    "answer": "option2",
    "solution": "Since ΔG = ΔH - TΔS, if ΔH is negative and ΔS is positive, ΔG is always negative regardless of T."
  },
  {
    "id": "chemistry20",
    "subject": "chemistry",
    "question": "According to First Law of Thermodynamics, the mathematical expression is:",
    "option1": "ΔU = q + w",
    "option2": "ΔU = q - w",
    "option3": "q = ΔU + TΔS",
    "option4": "ΔH = q + w",
    "answer": "option1",
    "solution": "The First Law states that change in internal energy equals heat supplied plus work done on system (ΔU = q + w)."
  },
  {
    "id": "chemistry21",
    "subject": "chemistry",
    "question": "What is the van't Hoff factor (i) for complete dissociation of K2SO4?",
    "option1": "1",
    "option2": "2",
    "option3": "3",
    "option4": "4",
    "answer": "option3",
    "solution": "K2SO4 dissociates into 2 K+ and 1 SO4(2-) ion, yielding 3 ions total. Therefore, i = 3."
  },
  {
    "id": "chemistry22",
    "subject": "chemistry",
    "question": "Which colligative property is preferred for determining the molar mass of biomolecules like proteins?",
    "option1": "Relative lowering of vapour pressure",
    "option2": "Depression in freezing point",
    "option3": "Elevation in boiling point",
    "option4": "Osmotic pressure",
    "answer": "option4",
    "solution": "Osmotic pressure measurements are carried out at room temperature and produce measurable values even for very dilute solutions of high mass proteins."
  },
  {
    "id": "chemistry23",
    "subject": "chemistry",
    "question": "According to Raoult's law, the relative lowering of vapour pressure of a solution containing a non-volatile solute is equal to:",
    "option1": "Mole fraction of solvent",
    "option2": "Mole fraction of solute",
    "option3": "Molarity of solute",
    "option4": "Molality of solute",
    "answer": "option2",
    "solution": "Raoult's law states (P0 - P)/P0 = x_solute, where x_solute is the mole fraction of the non-volatile solute."
  },
  {
    "id": "chemistry24",
    "subject": "chemistry",
    "question": "An azeotropic mixture of two liquids boils at a lower temperature than either of them when:",
    "option1": "It shows positive deviation from Raoult's law",
    "option2": "It shows negative deviation from Raoult's law",
    "option3": "It shows ideal behavior",
    "option4": "It forms a solid solution",
    "answer": "option1",
    "solution": "Solutions showing large positive deviations form minimum boiling azeotropes."
  },
  {
    "id": "chemistry25",
    "subject": "chemistry",
    "question": "Henry's Law constant KH increases with:",
    "option1": "Increase in temperature",
    "option2": "Decrease in temperature",
    "option3": "Increase in pressure",
    "option4": "Decrease in volume",
    "answer": "option1",
    "solution": "Gas solubility decreases with temperature increase, which corresponds to an increase in Henry's Law constant KH."
  },
  {
    "id": "chemistry26",
    "subject": "chemistry",
    "question": "What is the pH of a 0.001 M HCl solution?",
    "option1": "1",
    "option2": "2",
    "option3": "3",
    "option4": "4",
    "answer": "option3",
    "solution": "HCl completely dissociates, so [H+] = 10^-3 M. pH = -log[H+] = -log(10^-3) = 3."
  },
  {
    "id": "chemistry27",
    "subject": "chemistry",
    "question": "According to Le Chatelier's principle, adding heat to an exothermic reaction at equilibrium will shift equilibrium:",
    "option1": "To the right",
    "option2": "To the left",
    "option3": "No shift",
    "option4": "First right then left",
    "answer": "option2",
    "solution": "For exothermic reactions, heat is a product. Increasing temperature shifts equilibrium in the reverse direction (to the left)."
  },
  {
    "id": "chemistry28",
    "subject": "chemistry",
    "question": "Which of the following species acts as a Lewis acid?",
    "option1": "NH3",
    "option2": "BF3",
    "option3": "H2O",
    "option4": "OH-",
    "answer": "option2",
    "solution": "BF3 is electron-deficient (incomplete octet on B) and accepts an electron pair, making it a Lewis acid."
  },
  {
    "id": "chemistry29",
    "subject": "chemistry",
    "question": "The conjugate base of HSO4- is:",
    "option1": "H2SO4",
    "option2": "SO4(2-)",
    "option3": "SO3(2-)",
    "option4": "H+",
    "answer": "option2",
    "solution": "A conjugate base is formed by removing a proton (H+) from an acid: HSO4- -> H+ + SO4(2-)."
  },
  {
    "id": "chemistry30",
    "subject": "chemistry",
    "question": "What is the unit of solubility product (Ksp) for AgCl?",
    "option1": "mol L-1",
    "option2": "mol2 L-2",
    "option3": "mol3 L-3",
    "option4": "Dimensionless",
    "answer": "option2",
    "solution": "AgCl dissociates into Ag+ and Cl-. Ksp = [Ag+][Cl-] = s * s = s^2. Units = (mol L-1)^2 = mol2 L-2."
  },
  {
    "id": "chemistry31",
    "subject": "chemistry",
    "question": "What is the oxidation state of Mn in KMnO4?",
    "option1": "+2",
    "option2": "+4",
    "option3": "+6",
    "option4": "+7",
    "answer": "option4",
    "solution": "Let Mn oxidation state be x. K(+1) + x + 4(-2) = 0 => 1 + x - 8 = 0 => x = +7."
  },
  {
    "id": "chemistry32",
    "subject": "chemistry",
    "question": "The Nernst equation relates electrode potential to:",
    "option1": "Temperature only",
    "option2": "Concentration of ions",
    "option3": "Pressure only",
    "option4": "Volume of solution",
    "answer": "option2",
    "solution": "Nernst equation quantifies the effect of ion concentration and temperature on cell electrode potential."
  },
  {
    "id": "chemistry33",
    "subject": "chemistry",
    "question": "Which metal is used as a sacrificial anode to prevent corrosion of iron?",
    "option1": "Copper",
    "option2": "Zinc",
    "option3": "Silver",
    "option4": "Lead",
    "answer": "option2",
    "solution": "Zinc has a lower reduction potential than iron, so it corrodes preferentially when attached to iron (galvanization)."
  },
  {
    "id": "chemistry34",
    "subject": "chemistry",
    "question": "According to Faraday's First Law of Electrolysis, the mass of substance deposited is directly proportional to:",
    "option1": "Current only",
    "option2": "Time only",
    "option3": "Quantity of electricity",
    "option4": "Voltage",
    "answer": "option3",
    "solution": "m ∝ Q = I * t. Mass deposited is directly proportional to the total electric charge Q passed."
  },
  {
    "id": "chemistry35",
    "subject": "chemistry",
    "question": "The molar conductivity of an electrolyte increases with dilution because:",
    "option1": "Total number of ions increases drastically",
    "option2": "Interionic attraction decreases and mobility increases",
    "option3": "Solvent molecules dissociate",
    "option4": "Temperature increases",
    "answer": "option2",
    "solution": "Upon dilution, interionic interactions decrease, allowing ions to move more freely and increasing molar conductivity."
  },
  {
    "id": "chemistry36",
    "subject": "chemistry",
    "question": "What is the unit of rate constant for a first-order reaction?",
    "option1": "mol L-1 s-1",
    "option2": "L mol-1 s-1",
    "option3": "s-1",
    "option4": "L2 mol-2 s-1",
    "answer": "option3",
    "solution": "Rate = k[A]^1 => k = Rate / [A] = (mol L-1 s-1) / (mol L-1) = s-1."
  },
  {
    "id": "chemistry37",
    "subject": "chemistry",
    "question": "The half-life period of a first-order reaction is:",
    "option1": "Directly proportional to initial concentration",
    "option2": "Inversely proportional to initial concentration",
    "option3": "Independent of initial concentration",
    "option4": "Proportional to square of initial concentration",
    "answer": "option3",
    "solution": "For first order, t1/2 = 0.693 / k, which contains no concentration term."
  },
  {
    "id": "chemistry38",
    "subject": "chemistry",
    "question": "According to Arrhenius equation, the slope of ln(k) versus 1/T plot gives:",
    "option1": "-Ea / R",
    "option2": "Ea / R",
    "option3": "-Ea",
    "option4": "A / R",
    "answer": "option1",
    "solution": "ln(k) = ln(A) - (Ea / R)(1/T). Comparing with y = mx + c gives slope m = -Ea / R."
  },
  {
    "id": "chemistry39",
    "subject": "chemistry",
    "question": "If the rate of a reaction doubles when reactant concentration is quadrupled, what is the order of reaction?",
    "option1": "0",
    "option2": "0.5",
    "option3": "1",
    "option4": "2",
    "answer": "option2",
    "solution": "Rate ∝ [A]^n. 2 = (4)^n => 2^1 = (2^2)^n => 2n = 1 => n = 0.5."
  },
  {
    "id": "chemistry40",
    "subject": "chemistry",
    "question": "A catalyst increases the rate of a chemical reaction by:",
    "option1": "Increasing enthalpy change ΔH",
    "option2": "Lowering the activation energy",
    "option3": "Increasing overall free energy change",
    "option4": "Decreasing reactant energy",
    "answer": "option2",
    "solution": "A catalyst provides an alternate pathway with lower activation energy (Ea)."
  },
  {
    "id": "chemistry41",
    "subject": "chemistry",
    "question": "Which of the following elements has the highest electronegativity?",
    "option1": "Oxygen",
    "option2": "Chlorine",
    "option3": "Fluorine",
    "option4": "Nitrogen",
    "answer": "option3",
    "solution": "Fluorine is the most electronegative element in the periodic table with a Pauling value of 4.0."
  },
  {
    "id": "chemistry42",
    "subject": "chemistry",
    "question": "The general trend for ionization enthalpy across a period from left to right is:",
    "option1": "Decreases continuously",
    "option2": "Increases generally",
    "option3": "Remains constant",
    "option4": "First decreases then increases",
    "answer": "option2",
    "solution": "Nuclear charge increases across a period while atomic radius decreases, leading to an overall increase in ionization enthalpy."
  },
  {
    "id": "chemistry43",
    "subject": "chemistry",
    "question": "Which element has the most negative electron gain enthalpy in Group 17?",
    "option1": "Fluorine",
    "option2": "Chlorine",
    "option3": "Bromine",
    "option4": "Iodine",
    "answer": "option2",
    "solution": "Chlorine has a more negative electron gain enthalpy than Fluorine due to Fluorine's small atomic size and high inter-electronic repulsions."
  },
  {
    "id": "chemistry44",
    "subject": "chemistry",
    "question": "Which of the following is an amphoteric oxide?",
    "option1": "Na2O",
    "option2": "SO2",
    "option3": "Al2O3",
    "option4": "CaO",
    "answer": "option3",
    "solution": "Aluminium oxide (Al2O3) reacts with both acids and bases, making it amphoteric."
  },
  {
    "id": "chemistry45",
    "subject": "chemistry",
    "question": "Which ionic species has the smallest ionic radius?",
    "option1": "N3-",
    "option2": "O2-",
    "option3": "F-",
    "option4": "Na+",
    "answer": "option4",
    "solution": "These are isoelectronic species (10 electrons). Higher positive nuclear charge draws electrons closer, so Na+ (Z=11) is smallest."
  },
  {
    "id": "chemistry46",
    "subject": "chemistry",
    "question": "Which p-block element exhibits an inert pair effect most prominently?",
    "option1": "B",
    "option2": "Al",
    "option3": "Ga",
    "option4": "Tl",
    "answer": "option4",
    "solution": "Inert pair effect increases down the group. Thallium (Tl) in group 13 forms stable +1 oxidation state instead of +3."
  },
  {
    "id": "chemistry47",
    "subject": "chemistry",
    "question": "What is the oxidation state of phosphorus in orthophosphoric acid (H3PO4)?",
    "option1": "+1",
    "option2": "+3",
    "option3": "+5",
    "option4": "+4",
    "answer": "option3",
    "solution": "3(+1) + x + 4(-2) = 0 => 3 + x - 8 = 0 => x = +5."
  },
  {
    "id": "chemistry48",
    "subject": "chemistry",
    "question": "Which gas is evolved when copper reacts with dilute nitric acid?",
    "option1": "NO",
    "option2": "NO2",
    "option3": "N2O",
    "option4": "H2",
    "answer": "option1",
    "solution": "3Cu + 8HNO3(dilute) -> 3Cu(NO3)2 + 2NO + 4H2O. Nitric oxide (NO) is evolved."
  },
  {
    "id": "chemistry49",
    "subject": "chemistry",
    "question": "XeF4 has which molecular geometry?",
    "option1": "Tetrahedral",
    "option2": "Square planar",
    "option3": "Octahedral",
    "option4": "Seesaw",
    "answer": "option2",
    "solution": "XeF4 has 4 bond pairs and 2 lone pairs on Xenon. According to VSEPR theory, it adopts square planar geometry."
  },
  {
    "id": "chemistry50",
    "subject": "chemistry",
    "question": "Which of the following noble gases is used in MRI body scanners?",
    "option1": "Helium",
    "option2": "Neon",
    "option3": "Argon",
    "option4": "Krypton",
    "answer": "option1",
    "solution": "Liquid helium is used to cool superconducting magnets in MRI scanners."
  },
  {
    "id": "chemistry51",
    "subject": "chemistry",
    "question": "Transition metals exhibit variable oxidation states primarily due to involvement of:",
    "option1": "s-orbitals only",
    "option2": "(n-1)d and ns orbitals",
    "option3": "p-orbitals only",
    "option4": "f-orbitals only",
    "answer": "option2",
    "solution": "The energy gap between (n-1)d and ns electrons is small, allowing both to participate in bonding."
  },
  {
    "id": "chemistry52",
    "subject": "chemistry",
    "question": "Which of the following transition metal ions is colorless in aqueous solution?",
    "option1": "Cu2+",
    "option2": "Fe3+",
    "option3": "Sc3+",
    "option4": "Cr3+",
    "answer": "option3",
    "solution": "Sc3+ has an electronic configuration of [Ar] 3d0. Lacking d-electrons, no d-d transitions occur, making it colorless."
  },
  {
    "id": "chemistry53",
    "subject": "chemistry",
    "question": "Lanthanoid contraction is caused due to poor shielding by:",
    "option1": "5d electrons",
    "option2": "4f electrons",
    "option3": "6s electrons",
    "option4": "5p electrons",
    "answer": "option2",
    "solution": "4f electrons have diffuse shapes and provide poor shielding against effective nuclear charge, causing lanthanoid contraction."
  },
  {
    "id": "chemistry54",
    "subject": "chemistry",
    "question": "Potassium dichromate (K2Cr2O7) acts as a strong oxidizing agent in acidic medium and converts to:",
    "option1": "Cr3+",
    "option2": "Cr2+",
    "option3": "Cr6+",
    "option4": "Cr4+",
    "answer": "option1",
    "solution": "In acidic medium: Cr2O7(2-) + 14H+ + 6e- -> 2Cr3+ + 7H2O."
  },
  {
    "id": "chemistry55",
    "subject": "chemistry",
    "question": "What is the spin-only magnetic moment of Mn2+ ion?",
    "option1": "1.73 BM",
    "option2": "3.87 BM",
    "option3": "4.90 BM",
    "option4": "5.92 BM",
    "answer": "option4",
    "solution": "Mn2+ has 3d5 configuration (n = 5 unpaired electrons). Magnetic moment μ = sqrt(n(n+2)) = sqrt(5*7) = sqrt(35) ≈ 5.92 BM."
  },
  {
    "id": "chemistry56",
    "subject": "chemistry",
    "question": "What is the coordination number of Fe in [Fe(EDTA)]-?",
    "option1": "2",
    "option2": "4",
    "option3": "6",
    "option4": "8",
    "answer": "option3",
    "solution": "EDTA is a hexadentate ligand with 6 donor atoms, giving a coordination number of 6."
  },
  {
    "id": "chemistry57",
    "subject": "chemistry",
    "question": "According to Werner's theory, primary valency of a metal ion corresponds to its:",
    "option1": "Coordination number",
    "option2": "Oxidation state",
    "option3": "Atomic number",
    "option4": "Mass number",
    "answer": "option2",
    "solution": "Primary valencies are ionizable and correspond to the oxidation state of the central metal atom."
  },
  {
    "id": "chemistry58",
    "subject": "chemistry",
    "question": "What is the IUPAC name of [Co(NH3)6]Cl3?",
    "option1": "Hexaamminecobalt(II) chloride",
    "option2": "Hexaamminecobalt(III) chloride",
    "option3": "Cobalt hexaammine chloride",
    "option4": "Hexaamminetrichlorocobalt",
    "answer": "option2",
    "solution": "The cation is named first with 'hexaammine' for 6 NH3, 'cobalt' with oxidation state (III), followed by 'chloride'."
  },
  {
    "id": "chemistry59",
    "subject": "chemistry",
    "question": "Which type of isomerism is exhibited by [Co(NH3)5(SO4)]Br and [Co(NH3)5Br]SO4?",
    "option1": "Linkage isomerism",
    "option2": "Ionisation isomerism",
    "option3": "Coordination isomerism",
    "option4": "Solvate isomerism",
    "answer": "option2",
    "solution": "These isomers yield different ions in aqueous solution (Br- vs SO4(2-)), exemplifying ionisation isomerism."
  },
  {
    "id": "chemistry60",
    "subject": "chemistry",
    "question": "In a strong field octahedral complex, crystal field splitting energy (Δo) is:",
    "option1": "Equal to pairing energy",
    "option2": "Greater than pairing energy",
    "option3": "Less than pairing energy",
    "option4": "Zero",
    "answer": "option2",
    "solution": "Strong field ligands produce large crystal field splitting where Δo > P, favoring electron pairing (low spin)."
  },
  {
    "id": "chemistry61",
    "subject": "chemistry",
    "question": "Chromatography technique is primarily based on the principle of:",
    "option1": "Differential adsorption or partition",
    "option2": "Boiling point difference",
    "option3": "Solubility differences in single solvent",
    "option4": "Sublimation",
    "answer": "option1",
    "solution": "Chromatography separates components based on differential distribution between stationary and mobile phases."
  },
  {
    "id": "chemistry62",
    "subject": "chemistry",
    "question": "In Lassaigne's test for nitrogen, the Prussian blue color formed is due to:",
    "option1": "Fe3[Fe(CN)6]2",
    "option2": "Fe4[Fe(CN)6]3",
    "option3": "Na4[Fe(CN)6]",
    "option4": "Fe(SCN)3",
    "answer": "option2",
    "solution": "Prussian blue color is due to the formation of ferriferrocyanide, Fe4[Fe(CN)6]3."
  },
  {
    "id": "chemistry63",
    "subject": "chemistry",
    "question": "Dumas method is used for the quantitative estimation of:",
    "option1": "Halogens",
    "option2": "Sulphur",
    "option3": "Nitrogen",
    "option4": "Phosphorus",
    "answer": "option3",
    "solution": "Dumas and Kjeldahl methods are standard techniques used for nitrogen estimation in organic compounds."
  },
  {
    "id": "chemistry64",
    "subject": "chemistry",
    "question": "Steam distillation is suitable for purifying liquids that are:",
    "option1": "Soluble in water and boil without decomposition",
    "option2": "Steam volatile and immiscible with water",
    "option3": "Non-volatile and miscible with water",
    "option4": "Thermally unstable at low pressure",
    "answer": "option2",
    "solution": "Steam distillation is applied to substances that are steam-volatile and immiscible with water."
  },
  {
    "id": "chemistry65",
    "subject": "chemistry",
    "question": "In Kjeldahl's method, nitrogen in the organic compound is quantitatively converted into:",
    "option1": "N2 gas",
    "option2": "(NH4)2SO4",
    "option3": "NO2",
    "option4": "NH3 gas directly",
    "answer": "option2",
    "solution": "Digestion with concentrated H2SO4 converts organic nitrogen into ammonium sulphate, (NH4)2SO4."
  },
  {
    "id": "chemistry66",
    "subject": "chemistry",
    "question": "Which of the following carbocations is most stable?",
    "option1": "(CH3)3C+",
    "option2": "(CH3)2CH+",
    "option3": "CH3CH2+",
    "option4": "CH3+",
    "answer": "option1",
    "solution": "Tertiary carbocation (CH3)3C+ has 9 hyperconjugative alpha-hydrogens and strong inductive (+I) stabilization."
  },
  {
    "id": "chemistry67",
    "subject": "chemistry",
    "question": "What is the IUPAC name of CH3-CH=CH-COOH?",
    "option1": "But-2-enoic acid",
    "option2": "But-3-enoic acid",
    "option3": "Propenoic acid",
    "option4": "Butanoic acid",
    "answer": "option1",
    "solution": "Chain has 4 carbons with carboxylic acid at C1 and double bond starting at C2: But-2-enoic acid."
  },
  {
    "id": "chemistry68",
    "subject": "chemistry",
    "question": "Electrophiles are species that act as:",
    "option1": "Lewis bases",
    "option2": "Lewis acids",
    "option3": "Bronsted bases",
    "option4": "Free radicals only",
    "answer": "option2",
    "solution": "Electrophiles are electron-loving (electron-deficient) species that accept electron pairs, behaving as Lewis acids."
  },
  {
    "id": "chemistry69",
    "subject": "chemistry",
    "question": "The functional group isomer of ethanoic acid (CH3COOH) is:",
    "option1": "Methy formate (HCOOCH3)",
    "option2": "Ethanol",
    "option3": "Methanal",
    "option4": "Propanone",
    "answer": "option1",
    "solution": "Carboxylic acids and esters with same molecular formula (C2H4O2) are functional isomers. HCOOCH3 is methyl formate."
  },
  {
    "id": "chemistry70",
    "subject": "chemistry",
    "question": "Heterolytic cleavage of a C-Cl bond generates:",
    "option1": "Two free radicals",
    "option2": "A carbocation and a chloride ion",
    "option3": "A carbanion and a chlorine cation",
    "option4": "Neutral molecules",
    "answer": "option2",
    "solution": "Chlorine is more electronegative than carbon, taking both bonding electrons to form Cl- and C+ (carbocation)."
  },
  {
    "id": "chemistry71",
    "subject": "chemistry",
    "question": "Ozonolysis of propene followed by reaction with Zn/H2O yields:",
    "option1": "Methanal and Ethanal",
    "option2": "Two molecules of Ethanal",
    "option3": "Propanal only",
    "option4": "Propanone and Methanal",
    "answer": "option1",
    "solution": "Cleavage of CH3-CH=CH2 ozone complex gives CH3CHO (ethanal) and HCHO (methanal)."
  },
  {
    "id": "chemistry72",
    "subject": "chemistry",
    "question": "Which rule governs the addition of HBr to an unsymmetrical alkene in the absence of peroxides?",
    "option1": "Anti-Markovnikov rule",
    "option2": "Markovnikov rule",
    "option3": "Saytzeff rule",
    "option4": "Huckel rule",
    "answer": "option2",
    "solution": "Markovnikov's rule states that the negative part of the addendum adds to the carbon with fewer hydrogen atoms."
  },
  {
    "id": "chemistry73",
    "subject": "chemistry",
    "question": "Which aromatic compound satisfies Huckel's rule for aromaticity with 6 π electrons?",
    "option1": "Cyclobutadiene",
    "option2": "Benzene",
    "option3": "Cyclooctatetraene",
    "option4": "Cyclopropenyl cation",
    "answer": "option2",
    "solution": "Benzene is planar, fully conjugated, and has (4n+2) π electrons where n=1 (6 π electrons)."
  },
  {
    "id": "chemistry74",
    "subject": "chemistry",
    "question": "Ethyne reacts with water in the presence of HgSO4 and H2SO4 at 333 K to form:",
    "option1": "Ethanol",
    "option2": "Ethanal",
    "option3": "Ethanoic acid",
    "option4": "Ethene",
    "answer": "option2",
    "solution": "Hydration of ethyne yields an unstable enol (CH2=CH-OH) which tautomerizes to acetaldehyde (ethanal)."
  },
  {
    "id": "chemistry75",
    "subject": "chemistry",
    "question": "Wurtz reaction of methyl iodide in presence of dry ether yields:",
    "option1": "Methane",
    "option2": "Ethane",
    "option3": "Propane",
    "option4": "Butane",
    "answer": "option2",
    "solution": "2 CH3I + 2 Na -> CH3-CH3 (ethane) + 2 NaI."
  },
  {
    "id": "chemistry76",
    "subject": "chemistry",
    "question": "SN1 reactions proceed with complete or partial:",
    "option1": "Inversion of configuration only",
    "option2": "Retention of configuration only",
    "option3": "Racemisation",
    "option4": "Elimination",
    "answer": "option3",
    "solution": "SN1 passes through a planar carbocation intermediate allowing nucleophilic attack from both sides, leading to racemisation."
  },
  {
    "id": "chemistry77",
    "subject": "chemistry",
    "question": "Which halogen compound undergoes SN2 reaction fastest?",
    "option1": "CH3Cl",
    "option2": "CH3CH2Cl",
    "option3": "(CH3)2CHCl",
    "option4": "(CH3)3CCl",
    "answer": "option1",
    "solution": "SN2 rate depends inversely on steric hindrance. Methyl halide (CH3Cl) is least hindered and reacts fastest."
  },
  {
    "id": "chemistry78",
    "subject": "chemistry",
    "question": "Chlorobenzene reacts with chloral in the presence of conc. H2SO4 to yield:",
    "option1": "Gammaxene",
    "option2": "DDT",
    "option3": "Freon",
    "option4": "TNT",
    "answer": "option2",
    "solution": "2 C6H5Cl + CCl3CHO -> DDT + H2O."
  },
  {
    "id": "chemistry79",
    "subject": "chemistry",
    "question": "Finkelstein reaction is used for the synthesis of alkyl halides, specifically:",
    "option1": "Alkyl fluorides",
    "option2": "Alkyl iodides",
    "option3": "Alkyl chlorides",
    "option4": "Alkyl bromides",
    "answer": "option2",
    "solution": "R-Cl/Br + NaI in dry acetone -> R-I + NaCl/NaBr (Finkelstein reaction)."
  },
  {
    "id": "chemistry80",
    "subject": "chemistry",
    "question": "Which reagent converts ethyl bromide into ethyl isocyanide?",
    "option1": "KCN",
    "option2": "AgCN",
    "option3": "KNO2",
    "option4": "AgNO2",
    "answer": "option2",
    "solution": "AgCN is covalent, so nitrogen attacks carbon to form alkyl isocyanide (R-NC)."
  },
  {
    "id": "chemistry81",
    "subject": "chemistry",
    "question": "Phenol reacts with neutral FeCl3 solution to give a characteristic color:",
    "option1": "Red",
    "option2": "Violet",
    "option3": "Green",
    "option4": "Yellow",
    "answer": "option2",
    "solution": "Phenol forms a complex [Fe(OC6H5)6]3- with FeCl3 giving a violet coloration."
  },
  {
    "id": "chemistry82",
    "subject": "chemistry",
    "question": "Reimer-Tiemann reaction converts phenol into:",
    "option1": "Benzaldehyde",
    "option2": "Salicylaldehyde",
    "option3": "Benzoic acid",
    "option4": "Salicylic acid",
    "answer": "option2",
    "solution": "Phenol treated with CHCl3/NaOH forms salicylaldehyde (2-hydroxybenzaldehyde)."
  },
  {
    "id": "chemistry83",
    "subject": "chemistry",
    "question": "Lucas reagent consists of a mixture of:",
    "option1": "Conc. HCl and Anhydrous ZnCl2",
    "option2": "Conc. HNO3 and ZnCl2",
    "option3": "Dil. HCl and Anhydrous ZnCl2",
    "option4": "Conc. H2SO4 and CuSO4",
    "answer": "option1",
    "solution": "Lucas reagent is an equimolar solution of concentrated HCl and anhydrous ZnCl2."
  },
  {
    "id": "chemistry84",
    "subject": "chemistry",
    "question": "Anisole on heating with HI gives:",
    "option1": "Iodobenzene and methanol",
    "option2": "Phenol and methyl iodide",
    "option3": "Phenol and methanol",
    "option4": "Iodobenzene and methyl iodide",
    "answer": "option2",
    "solution": "C6H5-O-CH3 + HI -> C6H5OH (phenol) + CH3I (methyl iodide) because C6H5-O bond has partial double bond character."
  },
  {
    "id": "chemistry85",
    "subject": "chemistry",
    "question": "Primary, secondary, and tertiary alcohols can be distinguished by:",
    "option1": "Tollens test",
    "option2": "Lucas test",
    "option3": "Fehling test",
    "option4": "Biuret test",
    "answer": "option2",
    "solution": "Lucas test shows immediate turbidity for tertiary, within 5 minutes for secondary, and no turbidity at room temp for primary alcohols."
  },
  {
    "id": "chemistry86",
    "subject": "chemistry",
    "question": "Aldehydes and ketones react with hydroxylamine (NH2OH) to form:",
    "option1": "Hydrazones",
    "option2": "Oximes",
    "option3": "Semicarbazones",
    "option4": "Cyanohydrins",
    "answer": "option2",
    "solution": "Carbonyl compounds react with hydroxylamine with elimination of water to form oximes (>C=N-OH)."
  },
  {
    "id": "chemistry87",
    "subject": "chemistry",
    "question": "Which compound reduces Tollens' reagent to give a silver mirror?",
    "option1": "Propanone",
    "option2": "Benzophenone",
    "option3": "Ethanal",
    "option4": "Acetone",
    "answer": "option3",
    "solution": "Aldehydes like ethanal reduce ammoniacal silver nitrate (Tollens' reagent) to metallic silver."
  },
  {
    "id": "chemistry88",
    "subject": "chemistry",
    "question": "Cannizzaro reaction is given by aldehydes that:",
    "option1": "Contain at least one alpha-hydrogen",
    "option2": "Do not contain any alpha-hydrogen",
    "option3": "Contain beta-hydrogens only",
    "option4": "Are aromatic only",
    "answer": "option2",
    "solution": "Aldehydes lacking alpha-hydrogen atoms (like HCHO, C6H5CHO) undergo self-redox Cannizzaro reaction in strong base."
  },
  {
    "id": "chemistry89",
    "subject": "chemistry",
    "question": "Wolff-Kishner reduction converts carbonyl group (>C=O) into (>CH2) using:",
    "option1": "Zn-Hg / conc. HCl",
    "option2": "NH2NH2 / KOH in ethylene glycol",
    "option3": "LiAlH4 in ether",
    "option4": "Na / liquid NH3",
    "answer": "option2",
    "solution": "Wolff-Kishner reduction uses hydrazine (NH2NH2) followed by KOH in ethylene glycol under heat."
  },
  {
    "id": "chemistry90",
    "subject": "chemistry",
    "question": "Carboxylic acids on treatment with P2O5 upon heating form:",
    "option1": "Acid chlorides",
    "option2": "Acid anhydrides",
    "option3": "Esters",
    "option4": "Amides",
    "answer": "option2",
    "solution": "Phosphorus pentoxide (P2O5) dehydrates two carboxylic acid molecules into an acid anhydride."
  },
  {
    "id": "chemistry91",
    "subject": "chemistry",
    "question": "Hofmann bromamide degradation reaction converts an amide into a primary amine containing:",
    "option1": "Same number of carbon atoms",
    "option2": "One carbon atom less",
    "option3": "One carbon atom more",
    "option4": "Double the number of carbons",
    "answer": "option2",
    "solution": "R-CONH2 + Br2 + 4NaOH -> R-NH2 + Na2CO3 + 2NaBr + 2H2O. The product amine has one less carbon atom."
  },
  {
    "id": "chemistry92",
    "subject": "chemistry",
    "question": "Which amine gives a foul-smelling carbylamine test with CHCl3 and KOH?",
    "option1": "Primary amine",
    "option2": "Secondary amine",
    "option3": "Tertiary amine",
    "option4": "Quaternary ammonium salt",
    "answer": "option1",
    "solution": "Carbylamine test (isocyanide test) is exclusive to aliphatic and aromatic primary amines."
  },
  {
    "id": "chemistry93",
    "subject": "chemistry",
    "question": "Hinsberg reagent used to distinguish 1°, 2°, and 3° amines is:",
    "option1": "Benzoyl chloride",
    "option2": "Benzenesulphonyl chloride",
    "option3": "Acetyl chloride",
    "option4": "p-Toluidine",
    "answer": "option2",
    "solution": "Benzenesulphonyl chloride (C6H5SO2Cl) is known as Hinsberg reagent."
  },
  {
    "id": "chemistry94",
    "subject": "chemistry",
    "question": "Aniline on reaction with nitrous acid (NaNO2 + HCl) at 0-5 °C forms:",
    "option1": "Phenol",
    "option2": "Benzene diazonium chloride",
    "option3": "Nitrobenzene",
    "option4": "Chlorobenzene",
    "answer": "option2",
    "solution": "Diazotisation of aniline at 273-278 K yields benzene diazonium chloride."
  },
  {
    "id": "chemistry95",
    "subject": "chemistry",
    "question": "The correct order of basic strength of methyl substituted amines in aqueous solution is:",
    "option1": "(CH3)2NH > CH3NH2 > (CH3)3N > NH3",
    "option2": "(CH3)3N > (CH3)2NH > CH3NH2 > NH3",
    "option3": "CH3NH2 > (CH3)2NH > (CH3)3N > NH3",
    "option4": "NH3 > CH3NH2 > (CH3)2NH > (CH3)3N",
    "answer": "option1",
    "solution": "Due to inductive, solvation, and steric factors, the basicity order in aqueous medium is 2° > 1° > 3° > NH3 for methyl amines."
  },
  {
    "id": "chemistry96",
    "subject": "chemistry",
    "question": "Which of the following carbohydrates is a non-reducing sugar?",
    "option1": "Glucose",
    "option2": "Fructose",
    "option3": "Maltose",
    "option4": "Sucrose",
    "answer": "option4",
    "solution": "In sucrose, reducing groups of glucose and fructose are involved in glycosidic linkage, making it a non-reducing sugar."
  },
  {
    "id": "chemistry97",
    "subject": "chemistry",
    "question": "Which vitamin deficiency causes Scurvy?",
    "option1": "Vitamin A",
    "option2": "Vitamin B1",
    "option3": "Vitamin C",
    "option4": "Vitamin D",
    "answer": "option3",
    "solution": "Deficiency of Vitamin C (ascorbic acid) leads to scurvy."
  },
  {
    "id": "chemistry98",
    "subject": "chemistry",
    "question": "Proteins are polymers of alpha-amino acids linked together by:",
    "option1": "Glycosidic bonds",
    "option2": "Peptide bonds",
    "option3": "Phosphodiester bonds",
    "option4": "Hydrogen bonds",
    "answer": "option2",
    "solution": "Amino acids are joined via amide linkage (-CO-NH-), known as a peptide bond."
  },
  {
    "id": "chemistry99",
    "subject": "chemistry",
    "question": "The base present in RNA but absent in DNA is:",
    "option1": "Adenine",
    "option2": "Guanine",
    "option3": "Uracil",
    "option4": "Thymine",
    "answer": "option3",
    "solution": "RNA contains Uracil instead of Thymine, which is found in DNA."
  },
  {
    "id": "chemistry100",
    "subject": "chemistry",
    "question": "In salt analysis, group reagent for Group II cations (e.g., Cu2+, Pb2+) is:",
    "option1": "Dilute HCl",
    "option2": "H2S gas in presence of dilute HCl",
    "option3": "NH4OH in presence of NH4Cl",
    "option4": "H2S gas in presence of NH4OH",
    "answer": "option2",
    "solution": "Group II cations are precipitated as sulfides in acidic medium using H2S gas in presence of dilute HCl."
  },





  




]

export default AllQuestions;